import { breadcrumbsIntegration, browserTracingIntegration, captureException, captureMessage, init as SentryInit } from '@sentry/browser'

import { A11yModule } from '@angular/cdk/a11y'
import { OVERLAY_DEFAULT_CONFIG, OverlayModule } from '@angular/cdk/overlay'
import { registerLocaleData } from '@angular/common'
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http'
import { ChangeDetectorRef, ErrorHandler, Injectable, LOCALE_ID, NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { FormField, provideSignalFormsConfig } from '@angular/forms/signals'
import { NG_STATUS_CLASSES } from '@angular/forms/signals/compat'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'

import { routing } from './app.routing'

import { environment } from '../environments/environment'

// Fileuploads

// Firebase
import { ClipboardModule } from '@angular/cdk/clipboard'
import { DragDropModule } from '@angular/cdk/drag-drop'
import { ScrollingModule } from '@angular/cdk/scrolling'
import { CdkTableModule } from '@angular/cdk/table'
import { FirebaseLemonaid, FirebaseLemonator } from './_angular/service/firebase-lemonator.service'

// Material
const globalRippleConfig: RippleGlobalOptions = { disabled: true }

import { provideDateFnsAdapter } from '@angular/material-date-fns-adapter'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatButtonModule } from '@angular/material/button'
import { MatCardModule } from '@angular/material/card'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatChipsModule } from '@angular/material/chips'
import { DateAdapter, MAT_RIPPLE_GLOBAL_OPTIONS, RippleGlobalOptions } from '@angular/material/core'
import { MatButtonToggleModule } from '@angular/material/button-toggle'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatDialogModule } from '@angular/material/dialog'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatListModule } from '@angular/material/list'
import { MatMenuModule } from '@angular/material/menu'
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatRadioModule } from '@angular/material/radio'
import { MatSelectModule } from '@angular/material/select'
import { MatSidenavModule } from '@angular/material/sidenav'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar'
import { MatSortHeaderIntl, MatSortModule, SortDirection } from '@angular/material/sort'
import { MatStepperIntl, MatStepperModule } from '@angular/material/stepper'
import { MatTableModule } from '@angular/material/table'
import { MatTabsModule } from '@angular/material/tabs'
import { MatToolbarModule } from '@angular/material/toolbar'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatTreeModule } from '@angular/material/tree'
// Pipes
import { LemonatorNumberDateToDatePipe } from './_angular/_pipes/lemonator-date.pipe'
import { LemonatorKaannaTilinpaatosPipe } from './_angular/_pipes/lemonator-translate.pipe'
import { BigCurrencyPipe, BigCurrencyWithLocalePipe, CurrencyPipe, CurrencyWithLocalePipe } from './_jaettu-angular/_pipes/lemon-currency.pipe'
import {
  LemonDateAndTimePipe,
  LemonDatePipe,
  LemonDateWithLocalePipe,
  LemonLocalDatePipe,
  LemonLocalDateWithLocalePipe,
  LemonLocalToMonthAndYearPipe,
  LemonNumberDatePipe,
  LemonNumberDateWithLocaleNarrowPipe,
  LemonNumberDateWithLocalePipe,
  LemonNumberMonthToMonthAndYearPipe,
  LemonTimestampDateAndTimePipe,
  LemonTimestampDateAndTimeWithLocalePipe,
  LemonTimestampPipe,
  LemonTimestampWithLocalePipe,
} from './_jaettu-angular/_pipes/lemon-date.pipe'
import { BigDecimalPipe, BigDecimalWithLocalePipe, DecimalPipe, DecimalWithLocalePipe } from './_jaettu-angular/_pipes/lemon-decimal.pipe'
import { PrettyPrintJsonPipe } from './_jaettu-angular/_pipes/lemon-json.pipe'
import { LemonMaaPipe, LemonMaaWithlocalePipe } from './_jaettu-angular/_pipes/lemon-maa.pipe'
import { LemonKaannaPipe, LemonKaannaWithLocalePipe } from './_jaettu-angular/_pipes/lemon-translate.pipe'

// Directives
import { RightClickMatMenuDirective } from './_angular/_directives/mat-menu-right-click-trigger.directive'
import { JaettuValikkoDirective } from './_angular/_directives/jaettu-valikko.directive'
import { OnDisabledDirective } from './_angular/_directives/ondisabled.directive'
import { ResizedDirective } from './_angular/_directives/resized-event.directive'
import { CountToDirective } from './_jaettu-angular/_directives/count-to.directive'
import { MonthPickerDirective } from './_jaettu-angular/_directives/month-picker.directive'
import { NumberDatePickerDirective } from './_jaettu-angular/_directives/number-date-picker.directive'
import { LemonNumberOnlyDirective } from './_jaettu-angular/_directives/number-only.directive'
import { PlaceholderWithRequiredIndicatorDirective } from './_jaettu-angular/_directives/placeholder-with-required-indicator.directive'
import { TimeFormatDirective } from './_jaettu-angular/_directives/time-format.directive'

// Components
import { ToggleArrow } from './_angular/_components/toggle-arrow'
import { BarcodeComponent } from './_jaettu-angular/_components/barcode.component'
import { BrowserClockCheckComponent } from './_jaettu-angular/_components/browser-clock-check.component'
import { LoadingContentComponent } from './_jaettu-angular/_components/loading-content.component'
import { LoadingComponent } from './_jaettu-angular/_components/loading.component'
import { QrcodeComponent } from './_jaettu-angular/_components/qrcode.component'
import { ConfettiRain } from './kirjanpito/effects/confetti.component'

// Login, Forgot password, Reset password, home
import { AppMenuComponent } from './app-menu.component'
import { AppComponent } from './app.component'
import { LoggedOutComponent } from './login/loggedout.component'
import { LoginComponent } from './login/login.component'
import { SsoLoginComponent } from './login/sso-login.component'

// Dialogit
import { AreYouSureDialog } from './_jaettu-angular/_components/are-you-sure.dialog'
import { InfoDialog } from './_jaettu-angular/_components/info.dialog'
import { VirheDialog } from './_jaettu-angular/_components/virhe.dialog'
import { DialogHeaderWithHelpComponent } from './_jaettu-angular/component/dialog-header-with-help/dialog-header-with-help.component'
import { TaukoMuistutusDialog } from './asiakkaat/listaus/tauko-muistutus.dialog'
import { ChangelogDialog } from './changelog.dialog'
import { KirjanpitoLisaaTiliotteenSaldoDialog } from './kirjanpito/dialogit/kirjanpito-lisaa-tiliotteen-saldo.dialog'
import { KirjanpitoValmisDialog } from './kirjanpito/dialogit/kirjanpito-valmis.dialog'
import { LisaaTilitapahtumaDialog } from './kirjanpito/dialogit/lisaa-tilitapahtuma.dialog'
import { LaskuKommenttiDialog } from './laskut/dialogit/lasku-kommentti-lemonator.dialog'
import { VaihdaKieliDialog } from './vaihda-kieli.dialog'
import { ServiceWorkerCacheInfoDialog } from './yllapito/service-worker-cache/cache-info.dialog'

// Services
import { AlvLemonatorService } from './_angular/service/alv-lemonator.service'
import { DebugService } from './_angular/service/debug.service'
import { KirjanpitoKelloService } from './_angular/service/kirjanpito/kirjanpito-kello.service'
import { KirjautunutKayttajaService } from './_angular/service/kirjautunut-kayttaja.service'
import { KirjautunutTilintarkastajaService } from './_angular/service/kirjautunut-tilintarkastaja.service'
import { LemonHttpService } from './_angular/service/lemon-http.service'
import { SivultaPoistuminen } from './_angular/service/sivulta-poistuminen'
import { SsoLoginService } from './_angular/service/sso-login-service'
import { TagiVaritService } from './_angular/service/tagi-varit.service'
import { VeroilmoitusEventsService } from './_angular/service/veroilmoitus-events.service'
import { VersionTarkistusPalvelu } from './_angular/service/version-tarkistus.palvelu'
import { ProjektitService } from './_jaettu-angular/projektit.service'

import { CookieService } from './_jaettu-angular/service/cookie.service'
// import { CacheService } from './_jaettu-angular/service/cache.service'
import { AlvService } from './_jaettu-angular/service/alv.service'
import { DragAndDropService } from './_jaettu-angular/service/drag-and-drop.service'
import { FileSaverService } from './_jaettu-angular/service/file-saver'
import { FormValidationService } from './_jaettu-angular/service/form-validation.service'
import { LadataanService } from './_jaettu-angular/service/ladataan.service'
import { LemonTranslationService } from './_jaettu-angular/service/lemon-translation.service'
import { LocalStorageService } from './_jaettu-angular/service/local-storage.service'
import { MaaService } from './_jaettu-angular/service/maa.service'
import { PdfService } from './_jaettu-angular/service/pdf.service'
import { TiedostojenLataamisService } from './_jaettu-angular/service/tiedostojen-lataamis.service'
import { TimestampService } from './_jaettu-angular/service/timestamp-service'
import { VasenValikkoService } from './_jaettu-angular/service/vasen-valikko.service'
import { WindowSizeService } from './_jaettu-angular/service/window.service'

import { TimestampProviderBase } from '@lemon/core/service/timestamp-provider.interface'

import { KirjanpitajienRoolitUriService } from '@lemon/core-firebase/lemonator/service/kirjanpitajien-roolit-uri.service'
import { PyhapaivatService } from '@lemon/core/service/pyhapaiva.service'
import { HolviSharedUriService } from './_jaettu-lemonator/service/holvi-shared-uri.service'
import { YllapitoUriService } from './_jaettu-lemonator/service/yllapito-uri.service'

// Shared
import { FirestoreIndeksoija } from '@lemon/core-firebase/service/firestore.indeksoija'
import { KopioijaPalvelu } from '@lemon/core-firebase/service/kopioija.service'
import { KycUriService } from '@lemon/core-firebase/service/kyc-uri.service'
import { ToimittajaTunnisteService } from '@lemon/core-firebase/service/lasku/toimittaja-tunniste.service'
import { OptionLabelsService } from '@lemon/core-firebase/service/option-labels.service'
import { PushIlmoitusUriService } from '@lemon/core-firebase/service/push-ilmoitus-uri.service'
import { CountryLocalizationService, TranslationService } from '@lemon/core-firebase/service/translation.service'
import { VahvistettuKorkoService } from '@lemon/core-firebase/service/vahvistettu-korko.service'
import { VatNumberValidationService } from '@lemon/core-firebase/service/vat-number-validation.service'
import { BicService } from '@lemon/core/service/bic.service'
import { CodeCheckService } from '@lemon/core/service/code-check.service'
import { CurrencyService } from '@lemon/core/service/currency.service'
import { DateService } from '@lemon/core/service/date.service'
import { IbanService } from '@lemon/core/service/iban.service'
import { StringService } from '@lemon/core/service/string.service'
import { ViitenumeroService } from '@lemon/core/service/viitenumero.service'

// Logs
import { TrackingServiceLemonatorImpl } from './_angular/service/logs/tracking.service'
import { TrackingService } from './_jaettu-angular/tracking'

import {
  AjastettuTyoServiceAngular,
  ApixUriServiceAngular,
  AsiakasJaettuLemonaidServiceAngular,
  BankConsentUriServiceAngular,
  BicServiceAngular,
  CodeCheckServiceAngular,
  CurrencyServiceAngular,
  DateServiceAngular,
  FirestoreIndeksoijaAngular,
  IbanServiceAngular,
  KopioijaPalveluAngular,
  KycUriServiceAngular,
  LaskuIndeksoijaAngular,
  LaskuKopioijaAngular,
  LaskuKorkoServiceAngular,
  LaskuLahetyksenToistoServiceAngular,
  LaskuLahetystietojenLuojaAngular,
  LaskuSharedServiceAngular,
  LaskuSpostiServiceAngular,
  LaskuUriServiceAngular,
  PushIlmoitusUriServiceAngular,
  ReskontraServiceAngular,
  SahkoisenLaskunValittajaServiceAngular,
  StringServiceAngular,
  TilinpaatosUriServiceAngular,
  ToimittajaTunnisteServiceAngular,
  TositeIndeksoijaAngular,
  TositeKopioijaAngular,
  TositeUriServiceAngular,
  TranslationServiceAngular,
  VahvistettuKorkoServiceAngular,
  VatNumberValidationServiceAngular,
  ViitenumeroServiceAngular,
} from './_jaettu-angular/angularified-services'

import { AjastettuTyoService } from '@lemon/core-firebase/eraajot/ajastettu/ajastetut-tyot.service'
import { Aikakone } from './_jaettu-angular/service/aikakone'

// Guards
import { AsiakasGuard } from './_angular/_guards/asiakas.guard'
import { AuthGuard } from './_angular/_guards/auth.guard'
import { NakymaGuard } from './_angular/_guards/nakyma.guard'
import { TiimiGuard } from './_angular/_guards/tiimi.guard'
import { TilintarkastajaAsiakasGuard } from './_angular/_guards/tilintarkastaja-asiakas.guard'
import { TilintarkastajaAuthGuard } from './_angular/_guards/tilintarkastaja-auth.guard'
import { YberYllapitoGuard } from './_angular/_guards/yber-yllapito.guard'
import { YllapitoGuard } from './_angular/_guards/yllapito.guard'
import { NakymaOikeusService } from './_angular/service/nakyma-oikeus.service'

// Resolvit
import {
  AsiakasComponentDataResolve,
  KayttajaComponentDataResolve,
  KirjanpitoComponentDataResolve,
  TilintarkastajaAsiakasComponentDataResolve,
  TilintarkastajaKirjanpitoComponentDataResolve,
} from './_angular/_resolvers/asiakas.resolve'
import { KirjanpitajaComponentDataResolve } from './_angular/_resolvers/kirjanpitaja.resolve'
import { LaskuComponentDataResolve, LaskuKatseleComponentDataResolve, LaskuSelaaKatseleComponentDataResolve } from './_angular/_resolvers/lasku.resolve'
import { TilintarkastajaComponentDataResolve } from './_angular/_resolvers/tilintarkastaja.resolve'
import { TositeKatseleComponentDataResolve } from './_angular/_resolvers/tosite.resolve'

import { Subject } from 'rxjs'

import { LemonDateAdapter } from './_jaettu-angular/_material/LemonDateAdapter'
import { LemonDialogHeader } from './lemon-dialog-header.component'

// Tilastot
import { TilastotTiimaritComponent } from './tilastot/tilastot-tiimarit.component'
import { TilastotComponent } from './tilastot/tilastot.component'

// Kirjanpito
import { KirjanpitoLahetysAlvComponent } from './kirjanpito/kirjanpito-lahetys-alv.component'
import { KirjanpitoLahetysSignatureComponent } from './kirjanpito/kirjanpito-lahetys-signature.component'
import { KirjanpitoLahetysComponent } from './kirjanpito/kirjanpito-lahetys.component'
import { KirjanpitoProjektienTyylitComponent } from './kirjanpito/kirjanpito-projektien-tyylit.component'
import { KirjanpitoComponent } from './kirjanpito/kirjanpito.component'
import { KirjanpitoTilintarkastusComponent } from './tilintarkastajat/kirjanpito/tilintarkastus-kirjanpito.component'
// Tilintarkastus, hallinto
import { TilintarkastusHallintoComponent } from './tilintarkastajat/kirjanpito/hallinto/tilintarkastus-hallinto.component'

// Kirjanpito, raportit
import { KirjanpitoAlvIlmoitusComponent } from './kirjanpito/alv-ilmoitus.component'
import { KirjanpitoRaportitStandaloneComponent } from './kirjanpito/raportit-standalone.component'
import { KirjanpitoRaportitComponent } from './kirjanpito/raportit.component'
import { KirjanpitoRaportitAlvLaskelmaComponent } from './kirjanpito/raportit/alv-laskelma.component'
import { KirjanpitoRaportitOssComponent } from './kirjanpito/raportit/oss.component'
import { KirjanpitoRaportitPaakirjaComponent } from './kirjanpito/raportit/paakirja.component'
import { KirjanpitoRaportitTaselaskelmaVirallinenComponent } from './kirjanpito/raportit/taselaskelma-virallinen.component'
import { KirjanpitoRaportitTaselaskelmaComponent } from './kirjanpito/raportit/taselaskelma.component'
import { KirjanpitoRaportitTuloslaskelmaBruttoComponent } from './kirjanpito/raportit/tuloslaskelma-brutto.component'
import { KirjanpitoRaportitTuloslaskelmaVirallinenComponent } from './kirjanpito/raportit/tuloslaskelma-virallinen.component'
import { KirjanpitoRaportitTuloslaskelmaComponent } from './kirjanpito/raportit/tuloslaskelma.component'
import { KirjanpitoYhteisomyyntiIlmoitusComponent } from './kirjanpito/yhteisomyynti-ilmoitus.component'

// Kirjanpito, hallinto
import { ArkistoHallintoUploadDialog } from './kirjanpito/hallinto/arkisto-hallinto-upload.dialog'
import { ArkistoMuokkaaDialog } from './kirjanpito/hallinto/arkisto-muokkaa.dialog'
import { KirjanpitoHallintoComponent } from './kirjanpito/hallinto/kirjanpito-hallinto.component'
// Kirjanpito, tilinpäätös
import { KirjanpitoTilinpaatosComponent } from './kirjanpito/tilinpaatos.component'
import { KirjanpitoTilinpaatosLiitetiedotCheckboxComponent } from './kirjanpito/tilinpaatos/liitetiedot-checkbox.component'
import { KirjanpitoTilinpaatosLiitetiedotMultiInputCheckboxComponent } from './kirjanpito/tilinpaatos/liitetiedot-multi-input-checkbox.component'
import { KirjanpitoTilinpaatosLiitetiedotComponent } from './kirjanpito/tilinpaatos/liitetiedot.component'
import { KirjanpitoTilinpaatosLuetteloComponent } from './kirjanpito/tilinpaatos/luettelo.component'
import { KirjanpitoTilinpaatosRekisterointiComponent } from './kirjanpito/tilinpaatos/rekisterointi.component'
import { KirjanpitoTilinpaatosTaseErittelyComponent } from './kirjanpito/tilinpaatos/tase-erittely.component'
import { KirjanpitoTilinpaatosAloitusComponent } from './kirjanpito/tilinpaatos/tilinpaatos-aloitus.component'
import { KirjanpitoTilinpaatosLahetysEmailComponent } from './kirjanpito/tilinpaatos/tilinpaatos-lahetys-email.component'
import { KirjanpitoTilinpaatosLahetysComponent } from './kirjanpito/tilinpaatos/tilinpaatos-lahetys.component'
import { TilintarkastajaKutsuDialogComponent } from './kirjanpito/tilinpaatos/tilintarkastaja-kutsu-dialog.component'
import { KirjanpitoTilinpaatosTilintarkastusComponent } from './kirjanpito/tilinpaatos/tilintarkastus.component'

// Kirjanpito, veroilmoitus
import { KirjanpitoVeroilmoitusOy2020Component } from './kirjanpito/veroilmoitus/oy/veroilmoitus-oy-2020.component'
import { KirjanpitoVeroilmoitusOy2021Component } from './kirjanpito/veroilmoitus/oy/veroilmoitus-oy-2021.component'
import { KirjanpitoVeroilmoitusOy2022Component } from './kirjanpito/veroilmoitus/oy/veroilmoitus-oy-2022.component'
import { KirjanpitoVeroilmoitusOy2023Component } from './kirjanpito/veroilmoitus/oy/veroilmoitus-oy-2023.component'
import { KirjanpitoVeroilmoitusOy2024Component } from './kirjanpito/veroilmoitus/oy/veroilmoitus-oy-2024.component'
import { KirjanpitoVeroilmoitusOy2025Component } from './kirjanpito/veroilmoitus/oy/veroilmoitus-oy-2025.component'
import { KirjanpitoVeroilmoitusOy2026Component } from './kirjanpito/veroilmoitus/oy/veroilmoitus-oy-2026.component'
import { KirjanpitoVeroilmoitusTmi2020Component } from './kirjanpito/veroilmoitus/tmi/veroilmoitus-tmi-2020.component'
import { KirjanpitoVeroilmoitusTmi2021Component } from './kirjanpito/veroilmoitus/tmi/veroilmoitus-tmi-2021.component'
import { KirjanpitoVeroilmoitusTmi2022Component } from './kirjanpito/veroilmoitus/tmi/veroilmoitus-tmi-2022.component'
import { KirjanpitoVeroilmoitusTmi2023Component } from './kirjanpito/veroilmoitus/tmi/veroilmoitus-tmi-2023.component'
import { KirjanpitoVeroilmoitusTmi2024Component } from './kirjanpito/veroilmoitus/tmi/veroilmoitus-tmi-2024.component'
import { KirjanpitoVeroilmoitusTmi2025Component } from './kirjanpito/veroilmoitus/tmi/veroilmoitus-tmi-2025.component'
import { KirjanpitoVeroilmoitusAikaisemminLahetetytComponent } from './kirjanpito/veroilmoitus/veroilmoitus-aikaisemmin-lahetetyt-spostit.component'
import { KirjanpitoVeroilmoitusLahetysComponent } from './kirjanpito/veroilmoitus/veroilmoitus-lahetys.component'
import { KirjanpitoVeroilmoitusComponent } from './kirjanpito/veroilmoitus/veroilmoitus.component'

// Lomakkeet
import { Lomake62Oy2025Component } from './kirjanpito/veroilmoitus/oy/lomake-62-oy-2025.component'
import { Lomake62Oy2025Dialog } from './kirjanpito/veroilmoitus/oy/lomake-62-oy-2025.dialog'
import { Lomake62Oy2026Component } from './kirjanpito/veroilmoitus/oy/lomake-62-oy-2026.component'
import { Lomake62Oy2026Dialog } from './kirjanpito/veroilmoitus/oy/lomake-62-oy-2026.dialog'

import { KirjanpitoVeroilmoitusOsakkaatComponent } from './kirjanpito/veroilmoitus/components/veroilmoitus-osakkaat.component'
import { KirjanpitoVeroilmoitusOsakkaatDialog } from './kirjanpito/veroilmoitus/components/veroilmoitus-osakkaat.dialog'
import { KirjanpitoVeroilmoitusPartComponent } from './kirjanpito/veroilmoitus/components/veroilmoitus-part.component'
import { KirjanpitoVeroilmoitusRowCheckComponent } from './kirjanpito/veroilmoitus/components/veroilmoitus-row-check.component'
import { KirjanpitoVeroilmoitusRowDateRangeComponent } from './kirjanpito/veroilmoitus/components/veroilmoitus-row-date-range.component'
import { KirjanpitoVeroilmoitusRowDateComponent } from './kirjanpito/veroilmoitus/components/veroilmoitus-row-date.component'
import { KirjanpitoVeroilmoitusRowHeaderComponent } from './kirjanpito/veroilmoitus/components/veroilmoitus-row-header.component'
import { KirjanpitoVeroilmoitusRowNumberDoubleComponent } from './kirjanpito/veroilmoitus/components/veroilmoitus-row-number-double.component'
import { KirjanpitoVeroilmoitusRowNumberComponent } from './kirjanpito/veroilmoitus/components/veroilmoitus-row-number.component'
import { KirjanpitoVeroilmoitusRowRadioComponent } from './kirjanpito/veroilmoitus/components/veroilmoitus-row-radio.component'
import { KirjanpitoVeroilmoitusRowReadOnlyComponent } from './kirjanpito/veroilmoitus/components/veroilmoitus-row-read-only.component'
import { KirjanpitoVeroilmoitusRowStringComponent } from './kirjanpito/veroilmoitus/components/veroilmoitus-row-string.component'
import { KirjanpitoVeroilmoitusValueReadOnlyComponent } from './kirjanpito/veroilmoitus/components/veroilmoitus-value-read-only.component'

import { VeroilmoitusTranslationService } from './_jaettu-lemonator/service/veroilmoitus/veroilmoitus-translation.service'

// Kirjanpito, tositteet
import { PoistaLuottokorttilaskunLuomatKirjauksetDialog } from './kirjanpito/tositteet/poista-luottokorttilaskun-luomat-kirjaukset.dialog'
import { TeeLuottokorttilaskustaKirjauksetDialog } from './kirjanpito/tositteet/tee-luottokorttilaskusta-kirjaukset.dialog'
import { KirjanpitoTositeEsikatseluComponent } from './kirjanpito/tositteet/tosite-esikatselu.component'
import { KirjanpitoTositeKirjaamattomatTositteetComponent } from './kirjanpito/tositteet/tosite-kirjaamattomat.component'
import { KirjanpitoTositeNaytaKirjauksenTositteet } from './kirjanpito/tositteet/tosite-nayta-kirjauksen-tositteet.component'
import { KirjanpitoTositeNayttoComponent } from './kirjanpito/tositteet/tosite-naytto.component'
import { KirjanpitoTositeStandaloneComponent } from './kirjanpito/tositteet/tosite-standalone.component'

import { TositeMuokkaaYliajosummaaDialog } from './kirjanpito/dialogit/tosite.muokkaa-yliajosummaa.dialog'

import { KirjanpitoKuukausiStripService } from './_angular/service/kirjanpito/kirjanpito-kuukausistrip.service'
import { KirjanpitoAineistonLatausComponent } from './kirjanpito/aineiston-lataus/kirjanpito-aineiston-lataus.component'
import { KirjanpitoKelloComponent } from './kirjanpito/kirjanpito-kello.component'
import { KirjanpitoKuukausiStripComponent } from './kirjanpito/kirjanpito-kuukausistrip.component'
import { KirjanpitoTilintarkastusKuukausiStripComponent } from './tilintarkastajat/kirjanpito/tilintarkastus-kuukausistrip.component'

import { KirjanpitoAineistonLahetysDialog } from './kirjanpito/aineiston-lataus/kirjanpito-aineiston-lahetys.dialog'
import { KirjanpitoAineistonLatausUrlDialog } from './kirjanpito/aineiston-lataus/kirjanpito-aineiston-lataus-url.dialog'
import { KirjausJaksotaKuluDialog } from './kirjanpito/dialogit/kirjaus-jaksota-kulu.dialog'
import { KirjausAiAsetuksetDialog } from './kirjanpito/dialogit/kirjaus.ai-asetukset.dialog'
import { KirjausAiEhdotusIlmoitaDialog } from './kirjanpito/dialogit/kirjaus.ai-ehdotus-ilmoita.dialog'
import { KirjausDiagnoseHelpDialog } from './kirjanpito/dialogit/kirjaus.diagnose-help.dialog'
import { KirjausJaksotaDialog } from './kirjanpito/dialogit/kirjaus.jaksota.dialog'
import { KirjausKopioiDialog } from './kirjanpito/dialogit/kirjaus.kopioi.dialog'
import { KirjausMuokkaaViitenumeroaDialog } from './kirjanpito/dialogit/kirjaus.muokkaa-viitenumeroa.dialog'
import { KirjausMuutaPaivamaaraDialog } from './kirjanpito/dialogit/kirjaus.muuta-pvm.dialog'
import { KirjausMuutaSuoriteperusteiseksiDialog } from './kirjanpito/dialogit/kirjaus.muuta-suoriteperusteiseksi.dialog'
import { KirjausMuutaVatDialog } from './kirjanpito/dialogit/kirjaus.muuta-vat.dialog'
import { KirjausPoistaDialog } from './kirjanpito/dialogit/kirjaus.poista.dialog'
import { KirjausPoistotDialog } from './kirjanpito/dialogit/kirjaus.poistot.dialog'
import { KirjausSelvityspyyntoDialog } from './kirjanpito/dialogit/kirjaus.selvityspyynto.dialog'
import { KirjausSelvityspyyntohistoriaDialog } from './kirjanpito/dialogit/kirjaus.selvityspyyntohistoria.dialog'
import { KirjausSiirraDialog } from './kirjanpito/dialogit/kirjaus.siirra.dialog'
import { KirjanpitoReskontraTriangleComponent } from './kirjanpito/kirjanpito-reskontra-triangle.component'
import { KirjanpitoProjektitDropdownComponent } from './kirjanpito/projektit/projektit-dropdown.component'
import { KirjanpitoProjektitListausComponent } from './kirjanpito/projektit/projektit-listaus.component'
import { KirjanpitoProjektitListausDialog } from './kirjanpito/projektit/projektit-listaus.dialog'
import { KirjanpitoReskontraSingleBoxComponent } from './kirjanpito/reskontra/reskontra-single-box.component'
import { KirjanpitoReskontraComponent } from './kirjanpito/reskontra/reskontra.component'

import { KirjanpitoImageService } from 'app/_angular/service/kirjanpito/kirjanpito-image.service'
import { KirjanpitoRaportitAutosaveService } from 'app/_angular/service/kirjanpito/kirjanpito-raportit-autosave.service'
import { KirjanpitoTositeService } from 'app/_angular/service/kirjanpito/kirjanpito-tosite.service'
import { KirjanpitoImageHandlerService } from 'app/_angular/service/kirjanpito/kirjanpito.service'
import { KirjanpitajanAllekirjoitusService } from 'app/_jaettu-lemonator/service/kirjanpitajan-allekirjoitus.service'
import { KirjanpitoJaettuService } from 'app/_jaettu-lemonator/service/kirjanpito-jaettu.service'
import { KirjanpitoReskontraUriService } from 'app/_jaettu-lemonator/service/kirjanpito-reskontra-uri.service'
import { KirjanpitoUriService } from 'app/_jaettu-lemonator/service/kirjanpito-uri.service'
import { LlmTositeLukuMetatiedotService } from 'app/_jaettu-lemonator/service/llm-tosite-luku-metatiedot.service'
import { KirjanpitoNavigationService } from './_angular/service/kirjanpito/kirjanpito-navigation.service'
import { KirjanpitoRaportitVertailuTiedotService } from './_angular/service/kirjanpito/kirjanpito-raportit-vertailutiedot.service'
import { KirjanpitoService } from './_angular/service/kirjanpito/kirjanpito.service'

// Kirjanpito, Maksutavat
import { KirjanpitoMaksutavatComponent } from './kirjanpito/kirjanpito-maksutavat.component'
// Kirjanpito (ALV, VERO, emailit)
import { KirjanpitoLahetyksetComponent } from './kirjanpito/kirjanpito-lahetykset.component'

// Tilikartat
import { TilikarttaService } from './_angular/service/tilikartta.service'
import { TilikarttaJaettuService } from './_jaettu-lemonator/service/tilikartta-jaettu.service'
import { AsiakkaanTilikarttaEditComponent } from './asiakkaat/tilikartta/asiakkaan-tilikartta-edit.component'
import { AsiakkaanTilikarttaComponent } from './asiakkaat/tilikartta/asiakkaan-tilikartta.component'
import { AsiakkaanKirjanpitotiliMuokkaaPaatilikartanTiliaDialog } from './asiakkaat/tilikartta/kirjanpitotili-muokkaa-paatilikartan-tilia.dialog'
import { AsiakkaanKirjanpitotiliMuokkaaDialog } from './asiakkaat/tilikartta/kirjanpitotili-muokkaa.dialog'
import { KirjanpitotiliMuokkaaDialog } from './yllapito/tilikartta/kirjanpitotili-muokkaa.dialog'
import { PaatilikarttaComponent } from './yllapito/tilikartta/paatilikartta.component'
import { KirjanpitotiliProfiiliMuokkaaDialog } from './yllapito/tilikartta/profiili-kirjanpitotili-muokkaa.dialog'
import { PaatilikarttaProfiiliComponent } from './yllapito/tilikartta/profiili-paatilikartta.component'

// Asiakkaat
import { AsiakasOtsikkoComponent } from './asiakkaat/asiakas-otsikko.component'
// import { AsiakasKotiOtsikkoComponent } from './asiakkaat/asiakas-koti-otsikko.component'
import { AsiakasJaettuLemonaidService } from '@lemon/core-firebase/service/asiakas-jaettu-lemonaid.service'
import { AsiakasTyojonoLoadingService } from 'app/_angular/service/asiakas/asiakas-tyojono-loading.service'
import { AsiakasKopioija } from './_angular/service/asiakas/asiakas.kopioija'
import { AsiakasService, LaskuttavaAsiakasLemonatorProvider } from './_angular/service/asiakas/asiakas.service'
import { LaskuttavaAsiakasProvider } from './_jaettu-angular/service/lasku/laskuttava-asiakas.service'
import { AsiakasJaettuService } from './_jaettu-lemonator/service/asiakas-jaettu.service'
import { AsiakasUriService } from './_jaettu-lemonator/service/asiakas-uri.service'
import { AsiakasLisaaComponent } from './asiakkaat/asiakas-lisaa.component'
import { AsiakasLisaaEkaLaskutuskuukausiComponent } from './asiakkaat/asiakas-lisaa.pvm.component'
import { AsiakasTagitComponent } from './asiakkaat/asiakas-tagit.component'
import { AsiakashakuComponent } from './asiakkaat/asiakashaku.component'
import { AsiakkaanKayttajatComponent } from './asiakkaat/asiakkaan-kayttajat.component'
import { AsiakkaanKayttajatDataSourceService } from './asiakkaat/asiakkaan-kayttajat.datasource.service'
import { AsiakkaanMaksutavatAloitaPalvelutarjoajanVaihtoDialog } from './asiakkaat/asiakkaan-maksutavat-aloita-provider-vaihto'
import { AsiakkaanMaksutavatPoistaTilitapahtumatDialog } from './asiakkaat/asiakkaan-maksutavat-poista-tilitapahtumat.dialog'
import { AsiakkaanMaksutavatComponent } from './asiakkaat/asiakkaan-maksutavat.component'
import { AsiakkaanMaksutavatHistoriaDialog } from './asiakkaat/asiakkaan-maksutavat.historia.dialog'
import { AsiakkaanMaksutavatValitseKuvakeDialog } from './asiakkaat/asiakkaan-maksutavat.valitse-kuvake.dialog'
import { AsiakkaanTositteetComponent } from './asiakkaat/asiakkaan-tositteet.component'
import { AsiakasSalesListComponent } from './asiakkaat/sales.component'
import { AsiakasOmaveroMaksutiedotComponent } from './asiakkaat/yllapito/omavero-maksutiedot.component'

import { AsiakasTyojonoLoadingDetailsComponent } from './asiakkaat/asetukset/asiakas-tyojono-loading-details.component'
import { AsiakasAsetuksetAsiakastiedotComponent } from './asiakkaat/asetukset/asiakastiedot.component'
import { AsiakasAsetuksetGoogleSheetLinkkiDialog } from './asiakkaat/asetukset/google-sheet-linkki.dialog'
import { AsiakasAsetuksetKirjanpitotiedotComponent } from './asiakkaat/asetukset/kirjanpitotiedot.component'
import { AsiakasAsetuksetLaskutusComponent } from './asiakkaat/asetukset/laskutus.component'
import { AsiakasAsetuksetSopimuskaudetV2Component } from './asiakkaat/asetukset/sopimuskaudet-v2.component'
import { AsiakasAsetuksetSopimuskaudetComponent } from './asiakkaat/asetukset/sopimuskaudet.component'
import { AsiakkaanSopimuskausiPaataDialog } from './asiakkaat/asetukset/sopimuskausi-paata.dialog'
import { AsiakkaanSopimuskausiTaukoDialog } from './asiakkaat/asetukset/sopimuskausi-tauko.dialog'
import { AsiakkaanSopimuskausiTilaIkoni } from './asiakkaat/asetukset/sopimuskausi-tila.ikoni'
import { AsiakkaanSopimuskausiUusiDialog } from './asiakkaat/asetukset/sopimuskausi-uusi.dialog'
import { AsiakasAsetuksetSopimusversioComponent } from './asiakkaat/asetukset/sopimusversio.component'
import { TilikartanProfiiliVaihdaDialog } from './asiakkaat/asetukset/tilikartan-profiili-vaihda.dialog'
import { AsiakasAsetuksetRiskiarvioComponent } from './asiakkaat/asetukset/tuntemistiedot/tuntemistiedot-lomakkeet/asiakkaan-riskiarvio.component'
import { AsiakasAsetuksetOsakkaatHallitusEdunsaajatComponent } from './asiakkaat/asetukset/tuntemistiedot/tuntemistiedot-lomakkeet/osakkaat-hallitus-edunsaajat.component'
import { AsiakasAsetuksetRahanpesunSelvityksetComponent } from './asiakkaat/asetukset/tuntemistiedot/tuntemistiedot-lomakkeet/rahanpesun-selvitykset.component'
import { AsiakasAsetuksetTuntemistiedotComponent } from './asiakkaat/asetukset/tuntemistiedot/tuntemistiedot.component'
import { AsiakasAsetuksetTyokieltoAsetaDialog } from './asiakkaat/asetukset/tyokielto-aseta.dialog'
import { AsiakasAsetuksetTyokieltoPaataDialog } from './asiakkaat/asetukset/tyokielto-paata.dialog'
import { AsiakasAsetuksetYtjTiedotComponent } from './asiakkaat/asetukset/ytj-tiedot.component'

import { KayttajaKopioija } from './_angular/service/asiakas/kayttaja.kopioija'
import { KayttajaComponent } from './asiakkaat/kayttaja.component'

import { AsiakkaanTositteidenLataaminenDialog } from './asiakkaat/asiakkaan-tositteiden-lataaminen.dialog'
import { AsiakkaanTositteidenLataushistoriaDialog } from './asiakkaat/asiakkaan-tositteiden-lataushistoria.dialog'
import { KayttajaHaluatkoVarmastiLahettaaTaikalinkinDialog } from './asiakkaat/kayttaja.haluatko-varmasti-lahettaa-taikalinkin.dialog'
import { KayttajaHistoriaDialog } from './asiakkaat/kayttaja.historia.dialog'
import { KayttajaLoginHistoryDialog } from './asiakkaat/kayttaja.login-history.dialog'
import { KayttajaStrongAuthHistoryDialog } from './asiakkaat/kayttaja.strong-auth-history.dialog'
import { KayttajaVaihdaSalasanaDialog } from './asiakkaat/kayttaja.vaihda-salasana.dialog'

import { ArkistoService } from './_jaettu-lemonator/service/arkisto.service'
import { AjopaivakirjaContainerComponent } from './asiakkaat/ajopaivakirja/ajopaivakirja-container.component'
import { AjopaivakirjaLemonatorComponent } from './asiakkaat/ajopaivakirja/ajopaivakirja-lemonator.component'
import { UlkopuolisetKulutLemonatorComponent } from './asiakkaat/ajopaivakirja/ulkopuoliset-kulut-lemonator.component'
import { ArkistoSisainenUploadDialog } from './asiakkaat/arkisto-sisainen/arkisto-sisainen-upload.dialog'
import { ArkistoSisainenComponent } from './asiakkaat/arkisto-sisainen/arkisto-sisainen.component'

// Asiakkaan ylläpito
import { AiiaTilitapahtumatComponent } from './asiakkaat/yllapito/aiia/aiia-tilitapahtumat.component'
import { AiiaTyotComponent } from './asiakkaat/yllapito/aiia/aiia-tyot.component'
import { BankConnectionsComponent } from './asiakkaat/yllapito/bank-connections.component'
import { EnableBankingTilitapahtumatComponent } from './asiakkaat/yllapito/enable-banking/enable-banking-tilitapahtumat.component'

import { AjastetutTyotComponent } from './asiakkaat/yllapito/ajastetut-tyot.component'
import { AsiakkaanApixLaskujenTiedotComponent } from './asiakkaat/yllapito/apix-laskujen-tiedot.component'
import { HolviApiQueryComponent } from './asiakkaat/yllapito/holvi-api/holvi-api-query.component'
import { HolviTransactionDetailsDialog } from './asiakkaat/yllapito/holvi-api/holvi-api-transaction-details.dialog'
import { AsiakkaanKirjanpidonAlustaminenComponent } from './asiakkaat/yllapito/kirjanpidon-alustaminen.component'
import { AsiakkaanKirjanpitoLahetyksetComponent } from './asiakkaat/yllapito/kirjanpito-lahetykset.component'
import { AsiakkaanLemonaidLaskuasetuksetComponent } from './asiakkaat/yllapito/lemonaid-laskuasetukset.component'
import { YhteisomyyntiIlmoituksetComponent } from './asiakkaat/yllapito/yhteisomyynti-ilmoitukset.component'
import { YtjTiedotNakymaComponent } from './asiakkaat/yllapito/ytj-tiedot/ytj-tiedot-nakyma.component'

// Asiakaslistaus
import { AsiakkaanKirjanpitostatusKuukaudelleDialog } from './asiakkaat/listaus/asiakkaan-kirjanpitostatus-kuukaudelle.dialog'
import { AsiakkaanMuistiinpanotDialog } from './asiakkaat/listaus/asiakkaan-muistiinpanot.dialog'
import { AsiakkaatListausComponent } from './asiakkaat/listaus/asiakkaat-listaus.component'
import { AsiakkaatListausComponentOld } from './asiakkaat/listaus/asiakkaat-listaus.component-old'
import { AsiakkaatComponent } from './asiakkaat/listaus/asiakkaat.component'
import { AsiakkaatComponentOld } from './asiakkaat/listaus/asiakkaat.component-old'
import { AsiakkaatDataSourceStateService } from './asiakkaat/listaus/asiakkaat.datasource.service'

import { AsiakkaanKirjanpitajanSarakkeenArvonMuokkausDialog } from './asiakkaat/listaus/asiakkaan-kirjanpitajan-sarakkeen-arvon-muokkaus.dialog'
import { KirjanpitajanSarakkeenMuokkausDialog } from './asiakkaat/listaus/kirjanpitajan-sarakkeen-muokkaus.dialog'

// Laskut
import { LaskuKorkoService } from '@lemon/core-firebase/service/lasku/lasku-korko.service'
import { LaskuLahetyksenToistoService } from '@lemon/core-firebase/service/lasku/lasku-lahetyksen-toisto.service'
import { LaskuSharedService, ReskontraService } from '@lemon/core-firebase/service/lasku/lasku-shared.service'
import { LaskuSpostiService } from '@lemon/core-firebase/service/lasku/lasku-sposti.service'
import { LaskuUriService } from '@lemon/core-firebase/service/lasku/lasku-uri.service'
import { LaskuIndeksoija } from '@lemon/core-firebase/service/lasku/lasku.indeksoija'
import { LaskuKopioija } from '@lemon/core-firebase/service/lasku/lasku.kopioija'
import { SahkoisenLaskunValittajaService } from '@lemon/core-firebase/service/lasku/sahkoisen-laskun-valittaja.service'
import { LaskuPdfEsikatseluPerinteinenRajoitettuLeveyteenLemonator } from './_angular/_components/lasku.perinteinen-rajoitettu-leveyteen.component'
import { LaskuService } from './_angular/service/lasku/lasku.service'
import { LaskunAsiakasTypeahead, LaskunToimittajaTypeahead, LaskunTuoteTypeahead } from './_angular/service/lasku/lasku.typeahead'
import { LaskuEmailEsikatseluPerinteinen } from './_jaettu-angular/laskut/esikatselu/email.perinteinen.component'
import { LaskuPdfEsikatseluPerinteinen } from './_jaettu-angular/laskut/esikatselu/pdf.perinteinen.component'
import { LaskuAsiakkaanTiedotComponent } from './_jaettu-angular/laskut/muokkaa/lasku-asiakkaan-tiedot.component'
import { LaskuMuutTiedotComponent } from './_jaettu-angular/laskut/muokkaa/lasku-muut-tiedot.component'
import { LaskuYlaosanDropparitComponent } from './_jaettu-angular/laskut/muokkaa/lasku-ylaosan-dropparit.component'
import { KonfiguraatioPalvelu } from './_jaettu-angular/service/lasku/configuration.service'
import { LaskunAsiakasTypeaheadBase, LaskunTuoteTypeaheadBase } from './_jaettu-angular/service/lasku/typeahead.service'
import { AlvNumeronTarkistajaService } from './_jaettu-angular/service/vat-number-check.service'
import { LaskuMerkitseOsittainMaksetuksiLemonatorDialog } from './laskut/dialogit/lasku-merkitse-osittain-maksetuksi-lemonator.dialog'
import { LaskuHaluatkoVarmastiPeruaMaksetuksiMerkitsemisenLemonatorDialog } from './laskut/dialogit/lasku.haluatko-varmasti-perua-maksetuksi-merkitsemisen-lemonator.dialog'
import { LaskuKokoVirheDialog } from './laskut/dialogit/lasku.koko-virhe.dialog'
import { LaskuLataaLahetystiedostaDialog } from './laskut/dialogit/lasku.lataa-lahetystiedosta.dialog'
import { LaskuLataaDialog } from './laskut/dialogit/lasku.lataa.dialog'
import { LaskuSpostiDialog } from './laskut/dialogit/lasku.sposti.dialog'
import { LaskuRiviComponent } from './laskut/lasku-rivi.component'
import { LaskuRivitComponent } from './laskut/lasku-rivit.component'
import { LaskutusHakuStateService } from './_jaettu-angular/laskut/haku/laskutus-haku-state.service'
import { AsiakasrekisteriHakuLemonatorComponent } from './laskut/haku/asiakasrekisteri-haku-lemonator.component'
import { LaskuHakuLemonatorComponent } from './laskut/haku/lasku-haku-lemonator.component'
import { LaskuHakuDataSourceLemonator } from './laskut/haku/lasku-haku-lemonator.datasource'
import { TuoterekisteriHakuLemonatorComponent } from './laskut/haku/tuoterekisteri-haku-lemonator.component'
import { LaskuComponent } from './laskut/lasku.component'
import { LaskutComponent } from './laskut/laskut.component'
import { LaskuAsiakasSelaaKatseleComponent } from './laskut/selaa/lasku-asiakas-selaa.katsele.component'
import { LaskuAsiakkaatSelaaComponent } from './laskut/selaa/lasku-asiakkaat-selaa.component'
import { LaskutPiilotetutComponent } from './laskut/selaa/laskut-piilotetut.component'
import { LaskuSummatService, LaskutSelaaComponent } from './laskut/selaa/laskut-selaa.component'
import { OstolaskuSelaaKatseleComponent } from './laskut/selaa/ostolasku-selaa.katsele.component'
import { OstolaskutSelaaComponent } from './laskut/selaa/ostolaskut-selaa.component'
import { ToimittajaSelaaKatseleComponent } from './laskut/selaa/toimittaja-selaa.katsele.component'
import { ToimittajatSelaaComponent } from './laskut/selaa/toimittajat-selaa.component'
import { TuoteSelaaKatseleComponent } from './laskut/selaa/tuote-selaa.katsele.component'
import { TuotteetSelaaComponent } from './laskut/selaa/tuotteet-selaa.component'
import { ToistuvatLaskutSelaaComponent } from './laskut/toistuvat-laskut-selaa.component'
import { LahetaMuistutusDialog } from './yllapito/maksumuistutus/dialogit/laheta.dialog'
// import { LaskutFirestoreDataSource } from './laskut/laskut.firestore.datasource'
import { LaskuLahetystietojenLuoja } from '@lemon/core-firebase/service/lasku/lasku-lahetystietojen.luoja'
import { LaskuReskontraTiedotDialog } from './laskut/dialogit/lasku.reskontra-tiedot.dialog'
import { LahetaLemonatorComponent } from './laskut/laheta-lemonator.component'
import { LaskuKatseleComponent } from './laskut/lasku.katsele.component'
import { LaskutUusiDataSourceService } from './laskut/laskut.uusi.datasource.service'
import { LaskuSelaaKatseleComponent } from './laskut/selaa/lasku-selaa.katsele.component'
import { LaskutPiilotetutDataSourceService } from './laskut/selaa/laskut-piilotetut.datasource.service'
import { LaskutSelaaDataSourceService } from './laskut/selaa/laskut-selaa.datasource.service'

// Ylläpito
import { AsiakasImportComponent } from './asiakkaat/asetukset/import/asiakas-import.component'
import { ToimittajaImportComponent } from './asiakkaat/asetukset/import/toimittaja-import.component'
import { TuonnitComponent } from './asiakkaat/asetukset/import/tuonnit.component'
import { TuontiLahdejarjestelmaValintaDialog } from './asiakkaat/asetukset/import/tuonti-lahdejarjestelma-valinta.dialog'
import { TuoteImportComponent } from './asiakkaat/asetukset/import/tuote-import.component'
import { AlkusaldoImportComponent } from './asiakkaat/yllapito/alkusaldo-import.component'
import { HolviImportComponent } from './yllapito/holvi-import/holvi-import.component'
import { YllapitoHolviComponent } from './yllapito/integraatiot/holvi.component'
import { YllapitoVerohallintoComponent } from './yllapito/integraatiot/verohallinto.component'
import { KirjanpitajaLisaaUusiDialog } from './yllapito/kirjanpitajat/kirjanpitaja-lisaa-uusi.dialog'
import { KirjanpitajaComponent } from './yllapito/kirjanpitajat/kirjanpitaja.component'
import { KirjanpitajatComponent } from './yllapito/kirjanpitajat/kirjanpitajat.component'
import { MaksumuistutusComponent } from './yllapito/maksumuistutus/maksumuistutus.component'
import { MaksumuistutusService } from './yllapito/maksumuistutus/maksumuistutus.datasource.service'
import { LisaaJasenDialog } from './yllapito/tiimit/lisaa-jasen.dialog'
import { LisaaTiimiDialog } from './yllapito/tiimit/lisaa-tiimi.dialog'
import { MuokkaaJasenyysDialog } from './yllapito/tiimit/muokkaa-jasenyys.dialog'
import { MuokkaaTiimiDialog } from './yllapito/tiimit/muokkaa-tiimi.dialog'
import { TiimienHallintaService } from './yllapito/tiimit/tiimien-hallinta.service'
import { LisaaTiimiKokonaisuuteenDialog } from './yllapito/tiimit/tiimikokonaisuudet/lisaa-tiimi-kokonaisuuteen.dialog'
import { LisaaTiimikokonaisuusDialog } from './yllapito/tiimit/tiimikokonaisuudet/lisaa-tiimikokonaisuus.dialog'
import { MuokkaaKokonaisuudenTiimijaksoDialog } from './yllapito/tiimit/tiimikokonaisuudet/muokkaa-kokonaisuuden-tiimijakso.dialog'
import { MuokkaaTiimikokonaisuusDialog } from './yllapito/tiimit/tiimikokonaisuudet/muokkaa-tiimikokonaisuus.dialog'
import { TiimikokonaisuudetComponent } from './yllapito/tiimit/tiimikokonaisuudet/tiimikokonaisuudet.component'
import { TiimitComponent } from './yllapito/tiimit/tiimit.component'
import { YhteisomyyntilaskujenLataaminenDialog } from './yllapito/yhteisomyyntilaskujen-lataaminen.dialog'
import { YhteisomyyntilaskutComponent } from './yllapito/yhteisomyyntilaskut.component'
// import { KayttoehdotComponent } from './yllapito/kayttoehdot/kayttoehdot.component'
// import { KayttoehtojenJulkaiseminenDialog } from './yllapito/kayttoehdot/kayttoehtojen-julkaiseminen.dialog'
import { PankkienListausComponent } from './yllapito/pankkiyhteydet/pankkien-listaus.component'
import { SopimuksenJulkaiseminenDialog } from './yllapito/sopimukset/sopimuksen-julkaiseminen.dialog'
import { SopimuksetComponent } from './yllapito/sopimukset/sopimukset.component'
// import { PankkienSyncStatusComponent } from './yllapito/pankkiyhteydet/deprecated/pankkien-sync-status.component'
import { AjastetutTyotDataDialog } from './yllapito/ajastetut-tyot/ajastetut-tyot-data.dialog'
import { YllapitoAjastetutTyotComponent } from './yllapito/ajastetut-tyot/yllapito-ajastetut-tyot.component'
import { EmailTemplatesComponent } from './yllapito/email-templates/email-templates.component'
import { LoggingDataDialog } from './yllapito/logging/logging-data.dialog'
import { LoggingComponent } from './yllapito/logging/logging.component'
import { PankkiyhteydetComponent } from './yllapito/pankkiyhteydet/pankkiyhteydet.component'
import { ReportsComponent } from './yllapito/raportit/reports.component'
import { TilastonSiirtoTyokaluComponent } from './yllapito/tilastot/tilaston-siirto-tyokalu.component'

// Kirjanpitäjä
import { KirjanpitajanAsetuksetComponent } from './kirjanpitaja/kirjanpitajan-asetukset.component'

// Kirjanpitäjät
import { KirjanpitajaKopioija } from './_angular/service/kirjanpitaja/kirjanpitaja.kopioija'
import { KirjanpitajaService } from './_angular/service/kirjanpitaja/kirjanpitaja.service'
import { KirjanpitajanToimipisteService } from './_jaettu-lemonator/service/kirjanpitajan-toimipiste.service'

// Tositteet, selailu
import { TositeUriService } from '@lemon/core-firebase/service/tosite/tosite-uri.service'
import { TositeIndeksoija } from '@lemon/core-firebase/service/tosite/tosite.indeksoija'
import { TositeKopioija } from '@lemon/core-firebase/service/tosite/tosite.kopioija'
import { TositeHakuStateService } from './_angular/service/tosite/tosite-haku-state.service'
import { TositeKuvaService } from './_angular/service/tosite/tosite-kuva.service'
import { TositeService } from './_angular/service/tosite/tosite.service'
import { TositeSelvitysKorttiComponent } from './tositteet/selailu/selvitys-kortti/tosite-selvitys-kortti.component'
import { TositeSelailuHakuComponent } from './tositteet/selailu/tosite-haku/tosite-haku.component'
import { TositeSelailuKatseleComponent } from './tositteet/selailu/tosite.katsele.component'
import { TositeSelailuListausComponent } from './tositteet/selailu/tosite.listaus.component'
import { TositeSelailuListausFirebaseDataSource } from './tositteet/selailu/tosite.listaus.firebase.datasource'
import { TositeSelailuPoistaDialog } from './tositteet/selailu/tosite.poista.dialog'
import { TuontiKaynnistettyUudelleenDialog } from './tositteet/selailu/tuonti-kaynnistetty-uudelleen.dialog'

// Tilitapahtumat
import { TilitapahtumanTiedotDialog } from './yllapito/tilitapahtumat/tilitapahtuma-tiedot.dialog'
import { TilitapahtumatComponent } from './yllapito/tilitapahtumat/tilitapahtumat.component'
import { TilitapahtumatUusiDataSourceService } from './yllapito/tilitapahtumat/tilitapahtumat.uusi.datasource.service'
import { TilitapahtumienKohdistusdebugComponent } from './yllapito/tilitapahtumat/tilitapahtumien-kohdistusdebug.component'

import { PaivasaldoListausComponent } from './yllapito/tilitapahtumat/paivasaldot-listaus.component'

import { BankConsentUriService } from '@lemon/core-firebase/service/bank-consent-uri.service'
import { EmailTemplatesUriService } from './_jaettu-lemonator/service/email-templates-uri.service'
import { KirjanpitajanAsiakkaidenLaskutDataSourceService } from './yllapito/kirjanpitajan-asiakkaiden-laskut.datasource.service'

import { ItTyopoytaComponent } from './yllapito/it-tyopoyta/it-tyopoyta.component'
import { MobiilisovelluksienTilastotComponent } from './yllapito/it-tyopoyta/mobiilisovelluksien-tilastot.component'
import { LemonaidViestitComponent } from './yllapito/lemonaid-viestit/lemonaid-viestit.component'
import { LlmKirjausehdotusPalauteComponent } from './yllapito/llm-kirjausehdotus-palaute/llm-kirjausehdotus-palaute.component'
import { KategoriaAjotComponent } from './yllapito/llm-kirjausehdotus-testaus/alivalilehdet/kategoria-ajot.component'
import { KategoriaPromptiComponent } from './yllapito/llm-kirjausehdotus-testaus/alivalilehdet/kategoria-promptti.component'
import { KategoriaSetitComponent } from './yllapito/llm-kirjausehdotus-testaus/alivalilehdet/kategoria-setit.component'
import { LuoLuottokorttilaskuPromptDialog } from './yllapito/llm-kirjausehdotus-testaus/alivalilehdet/luo-luottokorttilasku-prompt.dialog'
import { LuottokorttilaskuPromptComponent } from './yllapito/llm-kirjausehdotus-testaus/alivalilehdet/luottokorttilasku-prompt.component'
import { GlobaaliPromptDialog } from './yllapito/llm-kirjausehdotus-testaus/globaali-prompt.dialog'
import { LisaaLlmTestisettiinDialog } from './yllapito/llm-kirjausehdotus-testaus/lisaa-testisettiin.dialog'
import { LlmKirjausehdotusTestausComponent } from './yllapito/llm-kirjausehdotus-testaus/llm-kirjausehdotus-testaus.component'
import { PromptiVersiovertailuComponent } from './yllapito/llm-kirjausehdotus-testaus/prompti-versiovertailu.component'
import { LisaaTositteetTestisettiinDialog } from './yllapito/llm-kirjausehdotus-testaus/tosite-luku/lisaa-tositteet-testisettiin.dialog'
import { MetatiedotFormComponent } from './yllapito/llm-kirjausehdotus-testaus/tosite-luku/metatiedot-form.component'
import { TositeLukuAjotComponent } from './yllapito/llm-kirjausehdotus-testaus/tosite-luku/tosite-luku-ajot.component'
import { TositeLukuPromptiComponent } from './yllapito/llm-kirjausehdotus-testaus/tosite-luku/tosite-luku-prompti.component'
import { TositeLukuSetitComponent } from './yllapito/llm-kirjausehdotus-testaus/tosite-luku/tosite-luku-setit.component'
import { TositeLukuTuotantoComponent } from './yllapito/llm-kirjausehdotus-testaus/tosite-luku/tosite-luku-tuotanto.component'
import { TositeLukuComponent } from './yllapito/llm-kirjausehdotus-testaus/tosite-luku/tosite-luku.component'

import {
  ArkistoServiceAngular,
  AsiakasJaettuServiceAngular,
  AsiakasUriServiceAngular,
  AsiakkaanSopimuskausiServiceAngular,
  EmailTemplatesUriServiceAngular,
  HolviSharedUriServiceAngular,
  KirjanpitajanAllekirjoitusServiceAngular,
  KirjanpitajanTiimiServiceAngular,
  KirjanpitajanToimipisteServiceAngular,
  KirjanpitajienRoolitUriServiceAngular,
  KirjanpitoJaettuServiceAngular,
  KirjanpitoReskontraUriServiceAngular,
  KirjanpitoUriServiceAngular,
  LlmTositeLukuMetatiedotServiceAngular,
  PoistotServiceAngular,
  PyhapaivatServiceAngular,
  SopimusUriServiceAngular,
  TilikarttaJaettuServiceAngular,
  TilinpaatosLiitetiedotJaettuServiceAngular,
  TilinpaatosTranslationServiceAngular,
  TilinpaatosUsersServiceAngular,
  TilintarkastajaServiceAngular,
  TuotteetServiceAngular,
  VeloituksetServiceAngular,
  VeroilmoitusLaskentaServiceAngular,
  VeroilmoitusTranslationServiceAngular,
  YllapitoUriServiceAngular,
} from './_angular/angularified-services'

import { ImageViewerComponentMultiple } from './_angular/_components/image-viewer-multiple.component'
import { ImageViewerComponent } from './_angular/_components/image-viewer.component'
import { ImageZoomComponent } from './_angular/_components/image-zoom.component'
import { PdfViewerComponent } from './_angular/_components/pdf-viewer.component'

// Logit
import { ButtonComponent } from './_angular/_components/button.component'
import { IconButtonComponent } from './_angular/_components/icon-button.component'
import { MenuItemButtonComponent } from './_angular/_components/menu-item-button.component'
import { PrimaryButtonComponent } from './_angular/_components/primary-button.component'
import { SecondaryButtonComponent } from './_angular/_components/secondary-button.component'

// Logit (jaettu)
import { LemonaidButtonComponent } from './_jaettu-angular/logs-jaettu/lemonaid-button.component'
import { LemonaidIconButtonComponent } from './_jaettu-angular/logs-jaettu/lemonaid-icon-button.component'
import { LemonaidMenuItemButtonComponent } from './_jaettu-angular/logs-jaettu/lemonaid-menu-item-button.component'
import { LemonaidPrimaryButtonComponent } from './_jaettu-angular/logs-jaettu/lemonaid-primary-button.component'
import { LemonaidSecondaryButtonComponent } from './_jaettu-angular/logs-jaettu/lemonaid-secondary-button.component'

// Quill text editor
import { QuillModule } from 'ngx-quill'

import { EnvironmentType } from './app.environment'

const isSentryEnabled = environment.airbrakeEnabled && !!window?.location?.hostname && !window.location.hostname.includes('local')

console.log('Enabled Sentry: ' + isSentryEnabled)

if (isSentryEnabled) {
  const sivultaPoistuminen = new SivultaPoistuminen(window)
  SentryInit({
    release: 'lemonator@' + environment.version,
    environment: environment.environment === EnvironmentType.PRODUCTION ? 'production' : 'beta',
    dsn: 'https://4eb722c81f066d5cea421c6f276349b9@o4509231716237312.ingest.de.sentry.io/4509231772336208',
    integrations: [breadcrumbsIntegration({ console: false }), browserTracingIntegration()],
    /** The percentage of how much traces to send. */
    tracesSampleRate: 0.2,
    // Sivun uudelleenlataus (kirjautumisen lopussa, version vaihtuessa, F5) keskeyttää kesken olevat funktiokutsut virheeseen "internal [0]"
    beforeSend: (event, hint) => (sivultaPoistuminen.keskeyttiFunktiokutsun(hint.originalException) ? null : event),
  })
}

@Injectable()
export class SentryService {
  captureStringMessage(message: string) {
    if (isSentryEnabled) {
      captureMessage(message)
    } else {
      console.error(message)
    }
  }
  captureError(error: Error) {
    if (isSentryEnabled) {
      captureException(error)
    } else {
      console.error(error)
    }
  }
}

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  constructor(private _snackbar: MatSnackBar) {}

  handleError(err: any): void {
    // Try local logging to console
    try {
      if (console) {
        console.error(err)
      }
    } catch (e) {}

    this._snackbar.open('TAPAHTUI VIRHE: OLE YSTÄVÄLLINEN JA ILMOITA TÄSTÄ YLLÄPIDOLLE. ENNEN JATKAMISTA, OLE HYVÄ JA LATAA SIVU UUDELLEEN.')

    try {
      if (isSentryEnabled) {
        const error = err.originalError || err

        if (
          Object.prototype.toString.call(error) === '[object Error]' ||
          Object.prototype.toString.call(error) === '[object ErrorEvent]' ||
          Object.prototype.toString.call(error) === '[object ProgressEvent]'
        ) {
          captureException(error)
        } else {
          captureMessage(error.error || error)
        }
      }
    } catch (error) {
      try {
        if (console) {
          console.error(err)
        }
      } catch (e) {}
    }

    try {
      // Try to avoid deep loop
      const debugCtx = err['ngDebugContext']
      const changeDetectorRef = debugCtx && debugCtx.injector.get(ChangeDetectorRef)
      if (changeDetectorRef) {
        changeDetectorRef.detach()
      }
    } catch (error) {
      try {
        if (console) {
          console.error(err)
        }
      } catch (e) {}
    }
  }
}

@Injectable()
export class MyMaterialMatStepperIntl implements MatStepperIntl {
  /**
   * Stream that emits whenever the labels here are changed. Use this to notify
   * components if the labels have changed after initialization.
   */
  changes: Subject<void> = new Subject()

  optionalLabel = ''
  completedLabel = ''
  editableLabel = ''

  constructor(private lemonTranslationService: LemonTranslationService) {
    lemonTranslationService.currentLanguageObservable.subscribe(kieli => {
      this.optionalLabel = this.lemonTranslationService.lokalisoiKielella('stepper.optional', kieli)
      this.completedLabel = this.lemonTranslationService.lokalisoiKielella('stepper.completed', kieli)
      this.editableLabel = this.lemonTranslationService.lokalisoiKielella('stepper.editable', kieli)
      this.changes.next()
    })
  }
}

@Injectable()
export class MyMaterialMatSortHeaderIntl implements MatSortHeaderIntl {
  /**
   * Stream that emits whenever the labels here are changed. Use this to notify
   * components if the labels have changed after initialization.
   */
  changes: Subject<void> = new Subject()

  /** ARIA label for the sorting button. */
  sortButtonLabel(id: string): string {
    return '// TODO: FIXME: IMPLEMENT ME'
  }

  /** A label to describe the current sort (visible only to screenreaders). */
  sortDescriptionLabel(id: string, direction: SortDirection): string {
    return '// TODO: FIXME: IMPLEMENT ME'
  }

  constructor(private lemonTranslationService: LemonTranslationService) {
    // lemonTranslationService.currentLanguageObservable.subscribe(kieli => {
    // this.changes.next()
    // })
  }
}

@Injectable()
export class MyMaterialPagingIntl implements MatPaginatorIntl {
  /**
   * Stream that emits whenever the labels here are changed. Use this to notify
   * components if the labels have changed after initialization.
   */
  changes: Subject<void> = new Subject()

  /** A label for the page size selector. */
  itemsPerPageLabel: string

  /** A label for the button that increments the current page. */
  nextPageLabel: string

  /** A label for the button that decrements the current page. */
  previousPageLabel: string

  /** A label for the button that moves to the first page. */
  firstPageLabel: string

  /** A label for the button that moves to the last page. */
  lastPageLabel: string

  constructor(private lemonTranslationService: LemonTranslationService) {
    lemonTranslationService.currentLanguageObservable.subscribe(kieli => {
      this.itemsPerPageLabel = this.lemonTranslationService.lokalisoiKielella('listaus.kpl-per-sivu', kieli)
      this.nextPageLabel = this.lemonTranslationService.lokalisoiKielella('listaus.seuraava-sivu', kieli)
      this.previousPageLabel = this.lemonTranslationService.lokalisoiKielella('listaus.edellinen-sivu', kieli)
      this.firstPageLabel = this.lemonTranslationService.lokalisoiKielella('listaus.ensimmainen-sivu', kieli)
      this.lastPageLabel = this.lemonTranslationService.lokalisoiKielella('listaus.viimeinen-sivu', kieli)
      this.changes.next()
    })
  }

  /** A label for the range of items within the current page and the length of the whole list. */
  getRangeLabel(page: number, pageSize: number, length: number): string {
    const lengthString = length === Number.MAX_SAFE_INTEGER ? '?' : '' + length

    if (length === 0 || pageSize === 0) {
      return '0 / ' + lengthString
    }
    length = Math.max(length, 0)
    const startIndex = page * pageSize
    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize
    return startIndex + 1 + ' - ' + endIndex + ' / ' + lengthString
  }
}

/**
 * Does not detach any subtrees. Reuses routes as long as their route config is the same.
 */
// @Injectable()
// export class LemonRouteReuseStrategy implements RouteReuseStrategy {

//   //   // private storepaths = ['', 'laskutus/tuotteet', 'laskutus/asiakkaat']
//   private cache = new Map<string, { route: ActivatedRouteSnapshot, detachedTree: DetachedRouteHandle }>()

//   shouldDetach(route: ActivatedRouteSnapshot): boolean {
//     const key = this.key(route.routeConfig.path)
//     // console.log('SHOULD DETACH "' + key + '"')
//     return key === 'asiakkaat'
//   }

//   store(route: ActivatedRouteSnapshot, detachedTree: DetachedRouteHandle): void {
//     if (route && route.routeConfig && route.routeConfig.path) {
//       const key = this.key(route.routeConfig.path)
//       if (detachedTree === null) {
//         // console.log('DELETE "' + key + '"')
//         // this.cache.delete(key)
//       } else if (key === 'asiakkaat') {
//         // console.log('STORE "' + key + '"')
//         this.cache.set(key, { route: route, detachedTree: detachedTree })
//       }
//     }
//   }

//   shouldAttach(route: ActivatedRouteSnapshot): boolean {
//     const key = this.key(route.routeConfig.path)
//     const attach: boolean = this.cache.get(key) !== null && this.cache.get(key) !== undefined
//     // console.log('SHOULD ATTACH ' + attach + ' "' + key + '"')
//     return attach
//   }

//   retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
//     if (route && route.routeConfig) {
//       const key = this.key(route.routeConfig.path)
//       const fromCache = this.cache.get(key)
//       // console.log('RETRIEVE "' + key + '"', fromCache)
//       return fromCache ? fromCache.detachedTree : null
//     }
//     return null
//   }

//   shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
//     return false
//   }

//   private key(key: string): string {
//     if (key === '') {
//       // return 'root'
//       return 'asiakkaat'
//     }
//     return key
//   }

// }

import localeFi from '@angular/common/locales/fi'

import { ApixUriService } from '@lemon/core-firebase/service/apix-uri.service'
import { TilinpaatosUriService } from '@lemon/core-firebase/service/tilinpaatos-uri.service'
import { TuotteetService } from '@lemon/core-firebase/service/tuotteet-service'
import { TilintarkastajaUriService } from 'app/_jaettu-lemonator/service/tilintarkastaja-uri.service'
import { TilintarkastajaService } from 'app/_jaettu-lemonator/service/tilintarkastaja.service'
import { VeloituksetService } from 'app/_jaettu-lemonator/service/veloitukset-service'
import { MoniyritystukiComponentDataResolve } from './_angular/_resolvers/moniyritystuki.resolve'
import { ProjektiServiceLemonatorImpl } from './_angular/service/kirjanpito/kirjanpito-projektit.service'
import { SharedFirebaseCurrentApp, SharedFirebaseLemonaid } from './_jaettu-angular/base-firebase.service'
import { KirjanpitajanTiimiService } from './_jaettu-lemonator/service/kirjanpitajan-tiimi.service'
import { PoistotService } from './_jaettu-lemonator/service/poistot.service'
import { SopimusUriService } from './_jaettu-lemonator/service/sopimus-uri.service'
import { AsiakkaanSopimuskausiService } from './_jaettu-lemonator/service/sopimuskausi.service'
import { TilinpaatosLiitetiedotJaettuService } from './_jaettu-lemonator/service/tilinpaatos-liitetiedot-jaettu.service'
import { TilinpaatosTranslationService } from './_jaettu-lemonator/service/tilinpaatos-translation.service'
import { TilinpaatosUsersService } from './_jaettu-lemonator/service/tilinpaatos-users.service'
import { VeroilmoitusLaskentaService } from './_jaettu-lemonator/service/veroilmoitus/veroilmoitus-laskenta.service'
import { MoniyritystuetComponent } from './yllapito/moniyritystuet/moniyritystuet.component'
import { MoniyritystukiComponent } from './yllapito/moniyritystuet/moniyritystuki.component'
import { TagiDialog } from './yllapito/tagit/tagi.dialog'
import { TagitComponent } from './yllapito/tagit/tagit.component'
import { TilintarkastajaComponent } from './yllapito/tilintarkastajat/tilintarkastaja.component'
import { TilintarkastajaLoginHistoryDialog } from './yllapito/tilintarkastajat/tilintarkastaja.login-history.dialog'
import { TilintarkastajatComponent } from './yllapito/tilintarkastajat/tilintarkastajat.component'
// Tunnistautuminen
import { TunnistautuminenService } from './_angular/service/tunnistautuminen.service'
import { TunnistautuminenNetsReturnComponent } from './tunnistautuminen/nets/nets-return.component'
import { TunnistautuminenNetsPankitComponent } from './tunnistautuminen/nets/pankit.component'
// Tilintarkastajat, tunnistautuminen
import { TilintarkastajaKirjautuminenComponent } from './tilintarkastajat/kirjautuminen/tilintarkastaja-kirjautuminen.component'
import { TilintarkastajaTunnistautuminenComponent } from './tilintarkastajat/tunnistautuminen/tilintarkastaja-tunnistautuminen.component'
import { TilintarkastajaKirjautuminenPankitComponent } from './tunnistautuminen/nets/tilintarkastaja-kirjautuminen-pankit.component'
import { TilintarkastajaTunnistautuminenPankitComponent } from './tunnistautuminen/nets/tilintarkastaja-tunnistautuminen-pankit.component'
// Tilintarkastajan toiminnot
import { TilintarkastajaAloitusComponent } from './tilintarkastajat/aloitus/tilintarkastaja-aloitus.component'
import { KirjanpitoTilintarkastusProjektitListausComponent } from './tilintarkastajat/kirjanpito/projektit/tilintarkastus-projektit-listaus.component'
import { KirjanpitoTilintarkastusRaportitComponent } from './tilintarkastajat/kirjanpito/raportit/tilintarkastus-raportit.component'
import { KirjanpitoTilintarkastusReskontraComponent } from './tilintarkastajat/kirjanpito/reskontra/tilintarkastus-reskontra.component'
import { AsiakkaanTilintarkastusTilikarttaEditComponent } from './tilintarkastajat/kirjanpito/tilikartta/tilintarkastus-tilikartta-edit.component'
import { KirjanpitoTilintarkastusAlvIlmoitusComponent } from './tilintarkastajat/kirjanpito/tilintarkastus-alv-ilmoitus.component'
import { KirjanpitoTilintarkastusLahetyksetComponent } from './tilintarkastajat/kirjanpito/tilintarkastus-kirjanpito-lahetykset.component'
import { KirjanpitoTilintarkastusYhteisomyyntiIlmoitusComponent } from './tilintarkastajat/kirjanpito/tilintarkastus-yhteisomyynti-ilmoitus.component'
import { KirjanpitoTilintarkastusTositeNaytaKirjauksenTositteet } from './tilintarkastajat/kirjanpito/tositteet/tilintarkastus-tosite-nayta-kirjauksen-tositteet.component'
import { KirjanpitoTilintarkastusTositeNayttoComponent } from './tilintarkastajat/kirjanpito/tositteet/tilintarkastus-tosite-naytto.component'
import { KirjanpitoTilintarkastusVeroilmoitusComponent } from './tilintarkastajat/kirjanpito/veroilmoitus/tilintarkastus-veroilmoitus.component'

// File drop
import { FileDropContentTemplateDirective } from './_jaettu-angular/file-drop/file-drop-templates.directive'
import { FileDropComponent } from './_jaettu-angular/file-drop/file-drop.component'
import { PushIlmoitusTyokaluComponent } from './yllapito/push-ilmoitukset/push-ilmoitus-tyokalu.component'

registerLocaleData(localeFi, 'fi')

@NgModule({
  declarations: [
    AppComponent,
    AppMenuComponent,
    LoginComponent,
    LoggedOutComponent,
    SsoLoginComponent,

    // File drop
    FileDropComponent,
    FileDropContentTemplateDirective,

    // Kirjanpito
    KirjanpitoComponent,
    KirjanpitoTilintarkastusComponent,
    TilintarkastusHallintoComponent,
    KirjanpitoLahetysComponent,
    KirjanpitoLahetysSignatureComponent,
    KirjanpitoLahetysAlvComponent,
    KirjanpitoProjektienTyylitComponent,
    // Kirjanpito, raportit
    KirjanpitoRaportitComponent,
    KirjanpitoRaportitStandaloneComponent,
    KirjanpitoRaportitTuloslaskelmaComponent,
    KirjanpitoRaportitTuloslaskelmaVirallinenComponent,
    KirjanpitoRaportitTaselaskelmaComponent,
    KirjanpitoRaportitTaselaskelmaVirallinenComponent,
    KirjanpitoRaportitPaakirjaComponent,
    KirjanpitoRaportitTuloslaskelmaBruttoComponent,
    KirjanpitoRaportitOssComponent,
    KirjanpitoRaportitAlvLaskelmaComponent,
    KirjanpitoAlvIlmoitusComponent,
    KirjanpitoYhteisomyyntiIlmoitusComponent,
    // Kirjanpito, hallinto
    KirjanpitoHallintoComponent,
    ArkistoHallintoUploadDialog,
    ArkistoMuokkaaDialog,
    // Kirjanpito, tilinpäätös
    KirjanpitoTilinpaatosComponent,
    KirjanpitoTilinpaatosAloitusComponent,
    TilintarkastajaKutsuDialogComponent,
    KirjanpitoTilinpaatosTaseErittelyComponent,
    KirjanpitoTilinpaatosLiitetiedotComponent,
    KirjanpitoTilinpaatosLuetteloComponent,
    KirjanpitoTilinpaatosLiitetiedotCheckboxComponent,
    KirjanpitoTilinpaatosLiitetiedotMultiInputCheckboxComponent,
    KirjanpitoTilinpaatosTilintarkastusComponent,
    KirjanpitoTilinpaatosRekisterointiComponent,
    KirjanpitoTilinpaatosLahetysComponent,
    KirjanpitoTilinpaatosLahetysEmailComponent,
    // Kirjanpito, veroilmoituskomponentit
    KirjanpitoVeroilmoitusComponent,
    KirjanpitoVeroilmoitusLahetysComponent,
    KirjanpitoVeroilmoitusAikaisemminLahetetytComponent,
    KirjanpitoVeroilmoitusPartComponent,
    KirjanpitoVeroilmoitusRowNumberComponent,
    KirjanpitoVeroilmoitusRowNumberDoubleComponent,
    KirjanpitoVeroilmoitusRowRadioComponent,
    KirjanpitoVeroilmoitusRowCheckComponent,
    KirjanpitoVeroilmoitusRowStringComponent,
    KirjanpitoVeroilmoitusRowReadOnlyComponent,
    KirjanpitoVeroilmoitusValueReadOnlyComponent,
    KirjanpitoVeroilmoitusRowDateComponent,
    KirjanpitoVeroilmoitusRowDateRangeComponent,
    KirjanpitoVeroilmoitusRowHeaderComponent,
    KirjanpitoVeroilmoitusOsakkaatComponent,
    KirjanpitoVeroilmoitusOsakkaatDialog,
    // Kirjanpito, Veroilmoitukset
    KirjanpitoVeroilmoitusTmi2020Component,
    KirjanpitoVeroilmoitusTmi2021Component,
    KirjanpitoVeroilmoitusTmi2022Component,
    KirjanpitoVeroilmoitusTmi2023Component,
    KirjanpitoVeroilmoitusTmi2024Component,
    KirjanpitoVeroilmoitusTmi2025Component,
    KirjanpitoVeroilmoitusOy2020Component,
    KirjanpitoVeroilmoitusOy2021Component,
    KirjanpitoVeroilmoitusOy2022Component,
    KirjanpitoVeroilmoitusOy2023Component,
    KirjanpitoVeroilmoitusOy2024Component,
    KirjanpitoVeroilmoitusOy2025Component,
    KirjanpitoVeroilmoitusOy2026Component,
    Lomake62Oy2025Dialog,
    Lomake62Oy2025Component,
    Lomake62Oy2026Dialog,
    Lomake62Oy2026Component,
    // Kirjanpito, tositteet
    KirjanpitoTositeEsikatseluComponent,
    KirjanpitoTositeKirjaamattomatTositteetComponent,
    KirjanpitoTositeNaytaKirjauksenTositteet,
    KirjanpitoTositeNayttoComponent,
    KirjanpitoTositeStandaloneComponent,
    TeeLuottokorttilaskustaKirjauksetDialog,
    PoistaLuottokorttilaskunLuomatKirjauksetDialog,
    TositeMuokkaaYliajosummaaDialog,
    KirjausPoistaDialog,
    KirjausAiEhdotusIlmoitaDialog,
    KirjausAiAsetuksetDialog,
    KirjausPoistotDialog,
    KirjausDiagnoseHelpDialog,
    KirjausMuutaPaivamaaraDialog,
    KirjausMuutaVatDialog,
    KirjausSiirraDialog,
    KirjausKopioiDialog,
    KirjausMuutaSuoriteperusteiseksiDialog,
    KirjausJaksotaDialog,
    KirjausJaksotaKuluDialog,
    KirjausMuokkaaViitenumeroaDialog,
    KirjausSelvityspyyntoDialog,
    KirjausSelvityspyyntohistoriaDialog,
    KirjanpitoAineistonLatausUrlDialog,
    KirjanpitoAineistonLahetysDialog,
    KirjanpitoAineistonLatausComponent,
    KirjanpitoKuukausiStripComponent,
    KirjanpitoTilintarkastusKuukausiStripComponent,
    KirjanpitoTilintarkastusTositeNayttoComponent,
    KirjanpitoTilintarkastusTositeNaytaKirjauksenTositteet,
    KirjanpitoTilintarkastusReskontraComponent,
    AsiakkaanTilintarkastusTilikarttaEditComponent,
    KirjanpitoTilintarkastusProjektitListausComponent,
    KirjanpitoTilintarkastusAlvIlmoitusComponent,
    KirjanpitoTilintarkastusYhteisomyyntiIlmoitusComponent,
    KirjanpitoTilintarkastusVeroilmoitusComponent,
    KirjanpitoTilintarkastusRaportitComponent,
    KirjanpitoTilintarkastusLahetyksetComponent,
    KirjanpitoKelloComponent,
    KirjanpitoProjektitDropdownComponent,
    KirjanpitoProjektitListausDialog,
    KirjanpitoProjektitListausComponent,
    KirjanpitoReskontraComponent,
    KirjanpitoReskontraSingleBoxComponent,
    KirjanpitoReskontraTriangleComponent,
    KirjanpitoMaksutavatComponent,
    KirjanpitoLahetyksetComponent,
    // Tilikartat
    PaatilikarttaComponent,
    PaatilikarttaProfiiliComponent,
    AsiakkaanTilikarttaComponent,
    AsiakkaanTilikarttaEditComponent,
    KirjanpitotiliMuokkaaDialog,
    KirjanpitotiliProfiiliMuokkaaDialog,
    AsiakkaanKirjanpitotiliMuokkaaDialog,
    AsiakkaanKirjanpitotiliMuokkaaPaatilikartanTiliaDialog,
    // Tilastot
    TilastotComponent,
    TilastotTiimaritComponent,
    // Asiakkaat
    AsiakasOtsikkoComponent,
    // AsiakasKotiOtsikkoComponent,
    AsiakkaatComponent,
    AsiakkaatComponentOld,
    AsiakkaatListausComponent,
    AsiakkaatListausComponentOld,
    // Asiakkaan asetukset
    AsiakasAsetuksetKirjanpitotiedotComponent,
    AsiakasAsetuksetLaskutusComponent,
    AsiakasAsetuksetSopimuskaudetComponent,
    AsiakasAsetuksetSopimuskaudetV2Component,
    AsiakasAsetuksetSopimusversioComponent,
    AsiakasAsetuksetAsiakastiedotComponent,
    AsiakasAsetuksetGoogleSheetLinkkiDialog,
    AsiakkaanSopimuskausiUusiDialog,
    AsiakkaanSopimuskausiPaataDialog,
    AsiakkaanSopimuskausiTaukoDialog,
    TilikartanProfiiliVaihdaDialog,
    AsiakkaanSopimuskausiTilaIkoni,
    AsiakasAsetuksetTyokieltoPaataDialog,
    AsiakasAsetuksetTyokieltoAsetaDialog,
    AsiakasAsetuksetYtjTiedotComponent,
    AsiakasAsetuksetTuntemistiedotComponent,
    AsiakasAsetuksetRahanpesunSelvityksetComponent,
    AsiakasAsetuksetRiskiarvioComponent,
    AsiakasAsetuksetOsakkaatHallitusEdunsaajatComponent,
    AsiakasTyojonoLoadingDetailsComponent,
    // Asiakkaan ajopäiväkirja/kirjanpidon ulkopuoliset kulut Lemonaidista
    AjopaivakirjaContainerComponent,
    AjopaivakirjaLemonatorComponent,
    UlkopuolisetKulutLemonatorComponent,
    ArkistoSisainenComponent,
    ArkistoSisainenUploadDialog,
    // Asiakkaan pankkiyhteydet
    BankConnectionsComponent,
    AiiaTilitapahtumatComponent,
    EnableBankingTilitapahtumatComponent,
    AiiaTyotComponent,
    // Asiakkaan ylläpito
    AsiakkaanApixLaskujenTiedotComponent,
    AsiakkaanLemonaidLaskuasetuksetComponent,
    AsiakkaanKirjanpitoLahetyksetComponent,
    AsiakasLisaaComponent,
    AsiakasOmaveroMaksutiedotComponent,
    AsiakasLisaaEkaLaskutuskuukausiComponent,
    AsiakasTagitComponent,
    AsiakkaanKayttajatComponent,
    AsiakkaanMaksutavatComponent,
    AsiakkaanMaksutavatValitseKuvakeDialog,
    AsiakkaanMaksutavatHistoriaDialog,
    AsiakkaanMaksutavatAloitaPalvelutarjoajanVaihtoDialog,
    AsiakkaanMaksutavatPoistaTilitapahtumatDialog,
    AsiakashakuComponent,
    AsiakasSalesListComponent,
    AsiakkaanTositteetComponent,
    KayttajaComponent,
    AsiakkaanTositteidenLataaminenDialog,
    AsiakkaanTositteidenLataushistoriaDialog,
    KayttajaVaihdaSalasanaDialog,
    KayttajaHaluatkoVarmastiLahettaaTaikalinkinDialog,
    KayttajaHistoriaDialog,
    KayttajaLoginHistoryDialog,
    KayttajaStrongAuthHistoryDialog,
    AsiakkaanKirjanpitostatusKuukaudelleDialog,
    AsiakkaanMuistiinpanotDialog,
    KirjanpitajanSarakkeenMuokkausDialog,
    AsiakkaanKirjanpitajanSarakkeenArvonMuokkausDialog,
    TilitapahtumatComponent,
    TilitapahtumienKohdistusdebugComponent,
    TilitapahtumanTiedotDialog,
    PaivasaldoListausComponent,
    // Laskut
    LaskuComponent,
    LaskutComponent,
    LaskutSelaaComponent,
    LaskuHakuLemonatorComponent,
    AsiakasrekisteriHakuLemonatorComponent,
    TuoterekisteriHakuLemonatorComponent,
    LaskutPiilotetutComponent,
    TuotteetSelaaComponent,
    TuoteSelaaKatseleComponent,
    LaskuAsiakkaatSelaaComponent,
    LaskuAsiakasSelaaKatseleComponent,
    OstolaskutSelaaComponent,
    OstolaskuSelaaKatseleComponent,
    ToimittajatSelaaComponent,
    ToimittajaSelaaKatseleComponent,
    ToistuvatLaskutSelaaComponent,
    // Ylläpito
    MaksumuistutusComponent,
    TilintarkastajatComponent,
    TilintarkastajaComponent,
    TilintarkastajaLoginHistoryDialog,
    MoniyritystukiComponent,
    MoniyritystuetComponent,
    TagitComponent,
    TagiDialog,
    TunnistautuminenNetsPankitComponent,
    TunnistautuminenNetsReturnComponent,
    // Tilintarkastajien tunnistautuminen
    TilintarkastajaTunnistautuminenPankitComponent,
    TilintarkastajaKirjautuminenPankitComponent,
    TilintarkastajaTunnistautuminenComponent,
    TilintarkastajaKirjautuminenComponent,
    TilintarkastajaAloitusComponent,
    YhteisomyyntilaskutComponent,
    YhteisomyyntilaskujenLataaminenDialog,
    KirjanpitajatComponent,
    KirjanpitajaComponent,
    KirjanpitajaLisaaUusiDialog,
    TiimitComponent,
    MuokkaaJasenyysDialog,
    LisaaJasenDialog,
    LisaaTiimiDialog,
    MuokkaaTiimiDialog,
    TiimikokonaisuudetComponent,
    LisaaTiimikokonaisuusDialog,
    LisaaTiimiKokonaisuuteenDialog,
    MuokkaaKokonaisuudenTiimijaksoDialog,
    MuokkaaTiimikokonaisuusDialog,
    HolviImportComponent,
    AlkusaldoImportComponent,
    TuoteImportComponent,
    AsiakasImportComponent,
    ToimittajaImportComponent,
    TuonnitComponent,
    TuontiLahdejarjestelmaValintaDialog,
    YllapitoVerohallintoComponent,
    YllapitoHolviComponent,
    // KayttoehdotComponent,
    // KayttoehtojenJulkaiseminenDialog,
    SopimuksetComponent,
    SopimuksenJulkaiseminenDialog,
    PankkiyhteydetComponent,
    PankkienListausComponent,
    YtjTiedotNakymaComponent,
    AsiakkaanKirjanpidonAlustaminenComponent,
    YhteisomyyntiIlmoituksetComponent,
    AjastetutTyotComponent,
    HolviApiQueryComponent,
    HolviTransactionDetailsDialog,
    ReportsComponent,
    EmailTemplatesComponent,
    YllapitoAjastetutTyotComponent,
    AjastetutTyotDataDialog,
    LoggingDataDialog,
    ItTyopoytaComponent,
    MobiilisovelluksienTilastotComponent,
    LlmKirjausehdotusTestausComponent,
    LemonaidViestitComponent,
    GlobaaliPromptDialog,
    LisaaLlmTestisettiinDialog,
    KategoriaPromptiComponent,
    KategoriaSetitComponent,
    KategoriaAjotComponent,
    LuottokorttilaskuPromptComponent,
    PromptiVersiovertailuComponent,
    LlmKirjausehdotusPalauteComponent,
    LuoLuottokorttilaskuPromptDialog,
    PushIlmoitusTyokaluComponent,
    TositeLukuComponent,
    TositeLukuPromptiComponent,
    TositeLukuSetitComponent,
    TositeLukuAjotComponent,
    TositeLukuTuotantoComponent,
    LisaaTositteetTestisettiinDialog,
    MetatiedotFormComponent,

    LoggingComponent,
    TilastonSiirtoTyokaluComponent,
    PrimaryButtonComponent,
    SecondaryButtonComponent,
    ButtonComponent,
    IconButtonComponent,
    MenuItemButtonComponent,
    LemonaidPrimaryButtonComponent,
    LemonaidSecondaryButtonComponent,
    LemonaidButtonComponent,
    LemonaidIconButtonComponent,
    LemonaidMenuItemButtonComponent,
    // Kirjanpitäjä
    KirjanpitajanAsetuksetComponent,
    // Ostotositteiden komponentit
    TositeSelailuListausComponent,
    TositeSelailuHakuComponent,
    TositeSelvitysKorttiComponent,
    TositeSelailuKatseleComponent,
    TositeSelailuPoistaDialog,
    TuontiKaynnistettyUudelleenDialog,
    // Dialogit
    LemonDialogHeader,
    VaihdaKieliDialog,
    ChangelogDialog,
    ServiceWorkerCacheInfoDialog,
    DialogHeaderWithHelpComponent,
    VirheDialog,
    AreYouSureDialog,
    InfoDialog,
    KirjanpitoValmisDialog,
    KirjanpitoLisaaTiliotteenSaldoDialog,
    LisaaTilitapahtumaDialog,
    TaukoMuistutusDialog,
    LaskuKommenttiDialog,
    // Yleiset
    BarcodeComponent,
    QrcodeComponent,
    LoadingComponent,
    LoadingContentComponent,
    LemonNumberOnlyDirective,
    MonthPickerDirective,
    NumberDatePickerDirective,
    RightClickMatMenuDirective,
    JaettuValikkoDirective,
    TimeFormatDirective,
    PlaceholderWithRequiredIndicatorDirective,
    ToggleArrow,
    CountToDirective,
    ResizedDirective,
    OnDisabledDirective,
    ConfettiRain,
    ImageZoomComponent,
    PdfViewerComponent,
    ImageViewerComponent,
    ImageViewerComponentMultiple,
    BrowserClockCheckComponent,
    // MultiSelectorComponent,
    // Pipes
    CurrencyPipe,
    BigCurrencyPipe,
    CurrencyWithLocalePipe,
    BigCurrencyWithLocalePipe,
    LemonKaannaPipe,
    LemonKaannaWithLocalePipe,
    LemonatorKaannaTilinpaatosPipe,
    LemonDatePipe,
    LemonDateAndTimePipe,
    LemonDateWithLocalePipe,
    LemonLocalDatePipe,
    LemonNumberDateWithLocaleNarrowPipe,
    LemonNumberDatePipe,
    LemonNumberDateWithLocalePipe,
    LemonLocalDateWithLocalePipe,
    LemonTimestampPipe,
    LemonTimestampWithLocalePipe,
    LemonTimestampDateAndTimePipe,
    LemonTimestampDateAndTimeWithLocalePipe,
    LemonLocalToMonthAndYearPipe,
    LemonNumberMonthToMonthAndYearPipe,
    LemonMaaPipe,
    LemonMaaWithlocalePipe,
    DecimalPipe,
    DecimalWithLocalePipe,
    BigDecimalPipe,
    BigDecimalWithLocalePipe,
    PrettyPrintJsonPipe,
    LemonatorNumberDateToDatePipe,
    // Laskut
    LahetaLemonatorComponent,
    LaskuRiviComponent,
    LaskuRivitComponent,
    LaskuYlaosanDropparitComponent,
    LaskuAsiakkaanTiedotComponent,
    LaskuMuutTiedotComponent,
    LaskuPdfEsikatseluPerinteinen,
    LaskuPdfEsikatseluPerinteinenRajoitettuLeveyteenLemonator,
    LaskuEmailEsikatseluPerinteinen,
    LaskuSpostiDialog,
    LaskuMerkitseOsittainMaksetuksiLemonatorDialog,
    LaskuReskontraTiedotDialog,
    LaskuKokoVirheDialog,
    LaskuLataaDialog,
    LaskuLataaLahetystiedostaDialog,
    LaskuHaluatkoVarmastiPeruaMaksetuksiMerkitsemisenLemonatorDialog,
    LaskuKatseleComponent,
    LaskuSelaaKatseleComponent,
    // Maksumuistutus
    LahetaMuistutusDialog,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    FormField,
    routing,
    // PdfViewerModule,
    // CDK below this
    A11yModule,
    CdkTableModule,
    ScrollingModule,
    DragDropModule,
    ClipboardModule,
    OverlayModule,
    // Material below this
    MatInputModule,
    MatListModule,
    MatStepperModule,
    MatButtonModule,
    MatMenuModule,
    MatSidenavModule,
    MatCardModule,
    MatToolbarModule,
    MatIconModule,
    MatSelectModule,
    MatDatepickerModule,
    MatAutocompleteModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatDialogModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatTabsModule,
    MatChipsModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatRadioModule,
    MatSnackBarModule,
    MatTreeModule,
    MatExpansionModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    // Quill text editor
    QuillModule.forRoot({
      modules: {
        toolbar: [
          [{ header: 1 }, { header: 2 }],
          ['bold', 'italic', 'underline'],
          [{ list: 'ordered' }, { list: 'bullet' }],
          // [{'script': 'sub'}, {'script': 'super' }],
          [{ color: [] }, { background: [] }], // dropdown with defaults from theme
          ['clean'],
        ],
      },
    }),
  ],
  providers: [
    // Sovelluksen tyylit värittävät virheelliset kentät ng-invalid- ja ng-touched-luokkien perusteella, joita Signal Forms ei muuten lisää
    provideSignalFormsConfig({ classes: NG_STATUS_CLASSES }),
    provideDateFnsAdapter({
      parse: {
        dateInput: 'P',
        timeInput: 'p',
      },
      display: {
        dateInput: 'P',
        timeInput: 'p',
        monthYearLabel: 'LLLL uuuu',
        dateA11yLabel: 'PP',
        monthYearA11yLabel: 'LLLL uuuu',
        timeOptionLabel: 'p',
      },
    }),
    { provide: LOCALE_ID, useValue: 'fi' },
    /** Tämä asetus on käytössä, jotta kirjauksien kirjausrivien autocompletet toimivat oikein.
     * Ilman tätä asetusta Angular 21 päivityksen jälkeen autocompletet ja fokusoinnit toimivat oudosti.
     * Liittyy tähän https://github.com/angular/components/issues/32642 */
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
    // Guards
    AuthGuard,
    AsiakasGuard,
    NakymaGuard,
    NakymaOikeusService,
    TilintarkastajaAuthGuard,
    TilintarkastajaAsiakasGuard,
    YllapitoGuard,
    TiimiGuard,
    YberYllapitoGuard,
    YllapitoGuard,
    // Resolvit
    TositeKatseleComponentDataResolve,
    AsiakasComponentDataResolve,
    TilintarkastajaAsiakasComponentDataResolve,
    TilintarkastajaKirjanpitoComponentDataResolve,
    LaskuComponentDataResolve,
    LaskuKatseleComponentDataResolve,
    LaskuSelaaKatseleComponentDataResolve,
    KayttajaComponentDataResolve,
    KirjanpitoComponentDataResolve,
    KirjanpitajaComponentDataResolve,
    TilintarkastajaComponentDataResolve,
    MoniyritystukiComponentDataResolve,
    // Services
    // Vain webin käytössä olevat palvelut
    DebugService,
    TagiVaritService,
    LemonHttpService,
    KirjautunutKayttajaService,
    KirjautunutTilintarkastajaService,
    LemonTranslationService,
    MaaService,
    PdfService,
    VasenValikkoService,
    TunnistautuminenService,
    FormValidationService,
    CookieService,
    // CacheService,
    WindowSizeService,
    LadataanService,
    LocalStorageService,
    TimestampService,
    DragAndDropService,
    TiedostojenLataamisService,
    VersionTarkistusPalvelu,
    TilikarttaService,
    SentryService,
    Aikakone,
    KirjanpitoKelloService,
    AlvLemonatorService,
    FileSaverService,
    OptionLabelsService,
    { provide: TrackingService, useClass: TrackingServiceLemonatorImpl },
    { provide: AlvService, useExisting: AlvLemonatorService },
    { provide: TilikarttaJaettuService, useClass: TilikarttaJaettuServiceAngular },
    // Shared
    { provide: BicService, useClass: BicServiceAngular },
    { provide: IbanService, useClass: IbanServiceAngular },
    { provide: ViitenumeroService, useClass: ViitenumeroServiceAngular },
    { provide: CurrencyService, useClass: CurrencyServiceAngular },
    { provide: DateService, useClass: DateServiceAngular },
    { provide: FirestoreIndeksoija, useClass: FirestoreIndeksoijaAngular },
    { provide: KopioijaPalvelu, useClass: KopioijaPalveluAngular },
    { provide: CodeCheckService, useClass: CodeCheckServiceAngular },
    { provide: TranslationService, useClass: TranslationServiceAngular },
    { provide: StringService, useClass: StringServiceAngular },
    { provide: YllapitoUriService, useClass: YllapitoUriServiceAngular },
    { provide: KirjanpitajienRoolitUriService, useClass: KirjanpitajienRoolitUriServiceAngular },
    { provide: PyhapaivatService, useClass: PyhapaivatServiceAngular },
    { provide: KirjanpitajanToimipisteService, useClass: KirjanpitajanToimipisteServiceAngular },
    { provide: KycUriService, useClass: KycUriServiceAngular },
    { provide: PushIlmoitusUriService, useClass: PushIlmoitusUriServiceAngular },
    { provide: TilinpaatosUriService, useClass: TilinpaatosUriServiceAngular },
    { provide: PoistotService, useClass: PoistotServiceAngular },
    { provide: TilinpaatosUsersService, useClass: TilinpaatosUsersServiceAngular },
    { provide: VatNumberValidationService, useClass: VatNumberValidationServiceAngular },
    { provide: ToimittajaTunnisteService, useClass: ToimittajaTunnisteServiceAngular },
    { provide: LlmTositeLukuMetatiedotService, useClass: LlmTositeLukuMetatiedotServiceAngular },
    { provide: HolviSharedUriService, useClass: HolviSharedUriServiceAngular },
    { provide: SopimusUriService, useClass: SopimusUriServiceAngular },
    { provide: TilinpaatosTranslationService, useClass: TilinpaatosTranslationServiceAngular },
    { provide: TilinpaatosLiitetiedotJaettuService, useClass: TilinpaatosLiitetiedotJaettuServiceAngular },
    { provide: AjastettuTyoService, useClass: AjastettuTyoServiceAngular },
    { provide: AsiakkaanSopimuskausiService, useClass: AsiakkaanSopimuskausiServiceAngular },
    { provide: ArkistoService, useClass: ArkistoServiceAngular },
    { provide: EmailTemplatesUriService, useClass: EmailTemplatesUriServiceAngular },
    { provide: BankConsentUriService, useClass: BankConsentUriServiceAngular },
    { provide: VahvistettuKorkoService, useClass: VahvistettuKorkoServiceAngular },
    { provide: ApixUriService, useClass: ApixUriServiceAngular },
    { provide: ProjektitService, useClass: ProjektiServiceLemonatorImpl },
    { provide: VeloituksetService, useClass: VeloituksetServiceAngular },
    { provide: TuotteetService, useClass: TuotteetServiceAngular },
    // Shared, Lasku
    { provide: LaskuIndeksoija, useClass: LaskuIndeksoijaAngular },
    { provide: LaskuKopioija, useClass: LaskuKopioijaAngular },
    { provide: LaskuKorkoService, useClass: LaskuKorkoServiceAngular },
    { provide: LaskuLahetyksenToistoService, useClass: LaskuLahetyksenToistoServiceAngular },
    { provide: ReskontraService, useClass: ReskontraServiceAngular },
    { provide: LaskuSharedService, useClass: LaskuSharedServiceAngular },
    { provide: LaskuSpostiService, useClass: LaskuSpostiServiceAngular },
    { provide: LaskuUriService, useClass: LaskuUriServiceAngular },
    { provide: SahkoisenLaskunValittajaService, useClass: SahkoisenLaskunValittajaServiceAngular },
    { provide: LaskuLahetystietojenLuoja, useClass: LaskuLahetystietojenLuojaAngular },
    // Shared in Angular, Lasku
    KonfiguraatioPalvelu,
    AlvNumeronTarkistajaService,
    LaskunAsiakasTypeahead,
    LaskunTuoteTypeahead,
    LaskunToimittajaTypeahead,
    LaskuService,
    LaskutUusiDataSourceService,
    MaksumuistutusService,
    TiimienHallintaService,
    LaskutSelaaDataSourceService,
    LaskutPiilotetutDataSourceService,
    VeroilmoitusEventsService,
    LaskuSummatService,
    LaskutusHakuStateService,
    LaskuHakuDataSourceLemonator,
    // Shared, Kuitti
    { provide: TositeUriService, useClass: TositeUriServiceAngular },
    { provide: TositeIndeksoija, useClass: TositeIndeksoijaAngular },
    { provide: TositeKopioija, useClass: TositeKopioijaAngular },
    { provide: VeroilmoitusLaskentaService, useClass: VeroilmoitusLaskentaServiceAngular },
    TositeService,
    TositeKuvaService,
    TositeSelailuListausFirebaseDataSource,
    TositeHakuStateService,
    // Kirjanpitäjät
    KirjanpitajaService,
    KirjanpitajaKopioija,
    KirjanpitajanAsiakkaidenLaskutDataSourceService,
    { provide: KirjanpitajanTiimiService, useClass: KirjanpitajanTiimiServiceAngular },
    // Asiakkaat
    AsiakasService,
    { provide: AsiakasUriService, useClass: AsiakasUriServiceAngular },
    { provide: AsiakasJaettuService, useClass: AsiakasJaettuServiceAngular },
    { provide: AsiakasJaettuLemonaidService, useClass: AsiakasJaettuLemonaidServiceAngular },
    AsiakasKopioija,
    KayttajaKopioija,
    AsiakkaatDataSourceStateService,
    AsiakkaanKayttajatDataSourceService,
    AsiakasTyojonoLoadingService,
    TilitapahtumatUusiDataSourceService,
    LaskuttavaAsiakasLemonatorProvider,
    { provide: TilintarkastajaService, useClass: TilintarkastajaServiceAngular },
    TilintarkastajaUriService,
    // Kirjanpito
    KirjanpitoService,
    KirjanpitoImageService,
    KirjanpitoImageHandlerService,
    KirjanpitoTositeService,
    KirjanpitoRaportitVertailuTiedotService,
    KirjanpitoKuukausiStripService,
    KirjanpitoRaportitAutosaveService,
    KirjanpitoNavigationService,
    { provide: KirjanpitoUriService, useClass: KirjanpitoUriServiceAngular },
    { provide: KirjanpitoJaettuService, useClass: KirjanpitoJaettuServiceAngular },
    { provide: VeroilmoitusTranslationService, useClass: VeroilmoitusTranslationServiceAngular },
    { provide: KirjanpitoReskontraUriService, useClass: KirjanpitoReskontraUriServiceAngular },
    // Asetukset
    { provide: KirjanpitajanAllekirjoitusService, useClass: KirjanpitajanAllekirjoitusServiceAngular },
    { provide: CountryLocalizationService, useExisting: MaaService },
    { provide: LaskuttavaAsiakasProvider, useExisting: LaskuttavaAsiakasLemonatorProvider },
    { provide: TimestampProviderBase, useExisting: TimestampService },
    { provide: LaskunAsiakasTypeaheadBase, useExisting: LaskunAsiakasTypeahead },
    { provide: LaskunTuoteTypeaheadBase, useExisting: LaskunTuoteTypeahead },
    { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleConfig },
    { provide: DateAdapter, useClass: LemonDateAdapter },
    { provide: LemonDateAdapter, useClass: LemonDateAdapter },
    // { provide: RouteReuseStrategy, useClass: LemonRouteReuseStrategy },
    { provide: ErrorHandler, useClass: SentryErrorHandler, deps: [MatSnackBar] },
    { provide: MatSortHeaderIntl, useClass: MyMaterialMatSortHeaderIntl },
    { provide: MatStepperIntl, useClass: MyMaterialMatStepperIntl },
    { provide: MatPaginatorIntl, useClass: MyMaterialPagingIntl },
    // Firebase
    FirebaseLemonator,
    FirebaseLemonaid,
    { provide: SharedFirebaseLemonaid, useExisting: FirebaseLemonaid },
    { provide: SharedFirebaseCurrentApp, useExisting: FirebaseLemonator },
    // Kirjautuminen
    SsoLoginService,
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ],
})
export class AppModule {}
